<template>
  <div class="container">
    <!-- <h1 class="text-center">EQUIPMENT FINANCING APPLICATION</h1> -->
    <form-wizard @on-complete="onComplete"
                  @on-change="scrollToTop"
                  ref="wizard"
                  shape="tab"
                  back-button-text="Go back!"
                  next-button-text="Continue"
                  finish-button-text="Submit Application"
                  color="#eff9ff">
        <div slot="title" class="amcredit-font minimal-title text-center text-12-16 f-w-600 color-grey-5 uppercase ls-1">Real Estate Application</div>
        <tab-content icon="far fa-estate" :before-change="validateFirstTab">
          <h3 class="title">Tell us about the property you want to finance and the loan program.</h3>
          <!-- <h5 class="color-green">Property Information</h5> -->
          <vue-form-generator :model="model" 
                              :schema="firstTabSchema"
                              :options="formOptions"
                              ref="firstTabForm"
                              >                        
          </vue-form-generator>
          <div :style="`display: ${model.financeType == 'PURCHASE' ? 'block' : 'none'}`">
            <vue-form-generator :model="model" 
                              :schema="purchaseSchema"
                              :options="formOptions"
                              ref="purchaseForm"
                              >                                
            </vue-form-generator>
          </div>
          <div :style="`display: ${(model.financeType == 'RATE AND TERM REFINANCE' || model.financeType == 'CASH-OUT REFINANCE') ? 'block' : 'none'}`">
            <vue-form-generator :model="model" 
                              :schema="refinanceSchema"
                              :options="formOptions"
                              ref="refinanceForm"
                              >                                
            </vue-form-generator>
          </div>
        </tab-content>
        <tab-content icon="far fa-sun" :before-change="validateSecondTab">
          <h3 class="title">List owner(s) of entity/company or property</h3>
          <h5 class="color-green">Name 1</h5>
          <vue-form-generator :model="model" 
                              :schema="secondTabSchema"
                              :options="formOptions"
                              ref="secondTabForm"
                              >                                
          </vue-form-generator>

          <div :style="`display: ${numOfOwner < 2 ? 'none' : 'block'}`">
            <hr class="col-lg-8">
            <h5 class="color-green">Name 2<a class="delete-add-owner" @click="deleteOwner2()">✕</a></h5>
            
            <vue-form-generator :model="model" 
                              :schema="addOwnerSchema2"
                              :options="formOptions"
                              ref="addOwner2Form"
                              >                                
            </vue-form-generator>
          </div>

          <div :style="`display: ${numOfOwner < 3 ? 'none' : 'block'}`">
            <hr class="col-lg-8">
            <h5 class="color-green">Name 3<a class="delete-add-owner" @click="deleteOwner2()">✕</a></h5>
            
            <vue-form-generator :model="model" 
                              :schema="addOwnerSchema3"
                              :options="formOptions"
                              ref="addOwner3Form"
                              >                                
            </vue-form-generator>
          </div>

          <div :style="`display: ${numOfOwner < 4 ? 'none' : 'block'}`">
            <hr class="col-lg-8">
            <h5 class="color-green">Name 4<a class="delete-add-owner" @click="deleteOwner2()">✕</a></h5>
            
            <vue-form-generator :model="model" 
                              :schema="addOwnerSchema4"
                              :options="formOptions"
                              ref="addOwner4Form"
                              >                                
            </vue-form-generator>
          </div>

          <!-- <div v-for="(addOwner, index) in addOwners" :key="index">
            <h5 class="color-green">Additional Business Owner<a class="delete-add-owner" @click="deleteOwner(index)">✕</a></h5>
            
            <vue-form-generator :model="addOwners[index]" 
                              :schema="addOwnerSchema"
                              :options="formOptions"
                              ref="addOwnerForm"
                              >                                
            </vue-form-generator>
            <hr class="col-lg-8">
            <input class="address-check-box" type="checkbox">
            <label class="address-check-label" v-bind:class="{checked: addOwner.toggle}" @click="addOwner.toggle = !addOwner.toggle">Use business address as my mailing address</label>
            <div v-show='!addOwner.toggle'>
              <br>
              <vue-form-generator :model="model" 
                                  :schema="mailingAddressSchema"
                                  :options="formOptions"
                                  ref="mailingAddressForm"
                                  >                                
              </vue-form-generator>
            </div>
            <hr class="col-lg-8">
          </div> -->
          <button class="amcredit-add-owner" :style="`display: ${numOfOwner == 4 ? 'none' : 'block'}`" @click="addOwner2()">Add Owner</button>

          <hr class="col-lg-8">
          <h5 class="color-green">Owner Special Situation</h5>
          <p class="color-red">(If “Yes” to any of the questions below, please attach a detailed Letter of Explanation on application review page.)</p>
          <vue-form-generator :model="model" 
                              :schema="ownerSpecialSchema"
                              :options="formOptions"
                              ref="ownerSpecialForm"
                              >                                
          </vue-form-generator>

          <!-- <div class="review-section col-lg-8 row">
            <div class="col-lg-6 remove-padding sub-title-margin"><h5 class="color-green">Comments (optional)</h5></div>
            <div class="remove-padding col-lg-12">
              <textarea v-model="brokerNote" name="application-notes" id="application-notes" cols="30" rows="4"></textarea>
            </div>
          </div> -->

          <hr class="col-lg-8">
          <h5 class="color-green">Contact Information</h5>
          <vue-form-generator :model="model" 
                              :schema="contactInfoSchema"
                              :options="formOptions"
                              ref="contactInfoForm"
                              >                                
          </vue-form-generator>
        
        </tab-content>
        <tab-content icon="far fa-consent" :before-change="validateConsentTab">
          <h3 class="title consent-title">Almost there. Let's review these required consent agreements.</h3>
          <div class="intro">Please review and agree to the required consents below. When you are ready, submit your application for review.</div>
          <div class="consent-item-wrapper col-lg-8 remove-padding">
            <div @click="displayCreditReport = true" data-open="credit-report-modal" class="flex-container consent-item align-middle" aria-controls="credit-report-modal" aria-haspopup="true" tabindex="0"><div class="media-wrap"><svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="24" cy="24" r="24" fill="#F0F4F0"></circle> <path d="M17 16L31 16V33H17V16Z" fill="white" stroke="#053a7a" stroke-width="2"></path> <path d="M20.5 24.5H27.5" stroke="#053a7a" stroke-linecap="round" stroke-linejoin="round"></path> <path d="M20.5 21.5H27.5" stroke="#053a7a" stroke-linecap="round" stroke-linejoin="round"></path> <path d="M20.5 27.5H27.5" stroke="#053a7a" stroke-linecap="round" stroke-linejoin="round"></path></svg></div> <div class="flex-container align-justify full-width"><a href="javascript:void(0);">
              Consent for American Credit to Obtain a Credit Report
            </a></div></div>
            <div @click="displayContactYou = true" data-open="contact-modal" class="flex-container consent-item align-middle" aria-controls="contact-modal" aria-haspopup="true" tabindex="0"><div class="media-wrap"><svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="24" cy="24" r="24" fill="#F0F4F0"></circle> <path d="M17 16L31 16V33H17V16Z" fill="white" stroke="#053a7a" stroke-width="2"></path> <path d="M20.5 24.5H27.5" stroke="#053a7a" stroke-linecap="round" stroke-linejoin="round"></path> <path d="M20.5 21.5H27.5" stroke="#053a7a" stroke-linecap="round" stroke-linejoin="round"></path> <path d="M20.5 27.5H27.5" stroke="#053a7a" stroke-linecap="round" stroke-linejoin="round"></path></svg></div> <div class="flex-container align-justify full-width"><a href="javascript:void(0);">
              Consent for American Credit to Contact You
            </a></div></div>
          </div>
          <div class="agree-box col-lg-8">
            <div class="row align-justify align-middle">
              <div class="col-md-8">
                <input class="consent-check-box" type="checkbox" id="agree" name="agree">
                <label class="consent-check-label" for="agree" v-bind:class="{checked: consentToggle}" @click="consentToggle = !consentToggle">I agree and acknowledge these consents for American Credit and its Assignees to obtain my credit report and contact me.</label>
              </div>
              <div class="col-md-4 consent-sign" :style="`display: ${consentToggle ? 'block' : 'none'}`">
                <div>
                  <div class="text">{{ model.firstName }} {{ model.lastName }}</div> 
                  <div class="text">{{ currentDate }}</div>
                </div>
              </div>
            </div>
          </div>
          <div class="important-notice col-lg-8 remove-padding">
            <p>IMPORTANT INFORMATION ABOUT PROCEDURES FOR BECOMING AN AMERICAN CREDIT CUSTOMER<br>
            To help the government fight the funding of terrorism and money laundering activities, Federal law requires all financial institutions to obtain, verify, and record information that identifies each person who receives funding from us.<br>
            What this means for you: When you request financing from us, we will ask for your name, address, date of birth, and other information that will allow us to identify you. We may also ask to see your driver's license or other identifying documents.</p>
            <p>NOTICE: The Federal Equal Credit Opportunity Act prohibits creditors from discriminating against credit applicants on the basis of race, color religion, national origin, sex, marital status, age (provided the applicant has the capacity to enter into a binding contract) because all or part of the applicant's income derives from any public assistance program, or because the applicant has, in good faith, exercised any right under the Consumer Credit Protection Act. The federal agency that administers our compliance with this law is the Federal Trade Commission, Equal Credit Opportunity, Washington, DC 20580</p>
          </div>
        </tab-content>
        <tab-content icon="far fa-rev">
          <h3 class="title">Final step! Review your application's information before you submit.</h3>
          <div class="review-section col-lg-8 row">
            <div class="col-lg-6 remove-padding"><h5 class="color-green">Property & Loan Information</h5></div>
            <div class="col-lg-6 remove-padding"><button class="edit-review uppercase" @click="editBusiness()">Edit</button></div>
            <h6 class="col-lg-6 sub-title remove-padding">Property</h6><div class="col-lg-6 remove-padding"></div>
            <div class="col-lg-6 remove-padding review-item row">
              <div class="col-lg-6 item-title">Address</div>
              <div class="col-lg-6 item-value">{{this.model.address}}<br>{{this.model.address2}}<br>{{this.model.city}},{{this.model.state}} {{this.model.zip}}</div>
            </div>
            <div class="col-lg-6 remove-padding review-item row">
              <div class="col-lg-6 item-title">Building sq. ft</div>
              <div class="col-lg-6 item-value">{{this.model.buildingSqft}}</div>
            </div>
            <div class="col-lg-6 remove-padding review-item row">
              <div class="col-lg-6 item-title">Number of units</div>
              <div class="col-lg-6 item-value">{{this.model.numberOfUnits}}</div>
            </div>
            <div class="col-lg-6 remove-padding review-item row">
              <div class="col-lg-6 item-title">Percent occupied</div>
              <div class="col-lg-6 item-value">{{this.model.percentOccupied}}%</div>
            </div>
            <div class="col-lg-6 remove-padding review-item row">
              <div class="col-lg-6 item-title">Does the owner occupy any portion of the building?</div>
              <div class="col-lg-6 item-value">{{this.model.ownerOccupied ? 'Yes' : 'No'}}</div>
            </div>
            <div class="col-lg-6 remove-padding review-item row">
              <div class="col-lg-6 item-title">If yes, how many sq. ft.?</div>
              <div class="col-lg-6 item-value">{{this.model.ownerOccupiedSqft}}</div>
            </div>
            <div class="col-lg-6 remove-padding review-item row">
              <div class="col-lg-6 item-title">Property type</div>
              <div class="col-lg-6 item-value">{{this.model.propertyType}}</div>
            </div>
            <div class="col-lg-6 remove-padding review-item row">
              <div class="col-lg-6 item-title">Property style</div>
              <div class="col-lg-6 item-value">{{this.model.propertyStyle}}</div>
            </div>
            <div class="col-lg-6 remove-padding review-item row">
              <div class="col-lg-6 item-title">The propety also have:</div>
              <div class="col-lg-6 item-value">{{this.model.propertyHave.join(', ')}}</div>
            </div>
            <div class="col-lg-6 remove-padding"></div><h6 class="col-lg-6 sub-title remove-padding sub-title-margin">Loan</h6><div class="col-lg-6 remove-padding"></div>
            <div class="col-lg-6 remove-padding review-item row">
              <div class="col-lg-6 item-title">Loan amount requested</div>
              <div class="col-lg-6 item-value">{{this.model.loanAmount}}</div>
            </div>
            <div class="col-lg-6 remove-padding review-item row">
              <div class="col-lg-6 item-title">Desired rate</div>
              <div class="col-lg-6 item-value">{{this.model.desiredRate}}%</div>
            </div>
            <div class="col-lg-6 remove-padding review-item row">
              <div class="col-lg-6 item-title">Amortization in months</div>
              <div class="col-lg-6 item-value">{{this.model.amortizationInMonths}}</div>
            </div>
            <div class="col-lg-6 remove-padding review-item row">
              <div class="col-lg-6 item-title">YSP rebate</div>
              <div class="col-lg-6 item-value">{{this.model.YSPRebate}}%</div>
            </div>
            <div class="col-lg-6 remove-padding review-item row">
              <div class="col-lg-6 item-title">Current estimated value</div>
              <div class="col-lg-6 item-value">{{this.model.currentEstimatedValue}}</div>
            </div>
            <div class="col-lg-6 remove-padding review-item row">
              <div class="col-lg-6 item-title">Monthly pmt</div>
              <div class="col-lg-6 item-value">{{this.model.monthlyPmt}}</div>
            </div>
            <div class="col-lg-6 remove-padding review-item row">
              <div class="col-lg-6 item-title">Annual pmt</div>
              <div class="col-lg-6 item-value">{{this.model.annualPmt}}</div>
            </div>
            <div class="col-lg-6 remove-padding review-item row">
              <div class="col-lg-6 item-title">Annual gross income</div>
              <div class="col-lg-6 item-value">{{this.model.annualGrossIncome}}</div>
            </div>
            <div class="col-lg-6 remove-padding review-item row">
              <div class="col-lg-6 item-title">Annual operating expense</div>
              <div class="col-lg-6 item-value">{{this.model.annualOperatingExpense}}</div>
            </div>
            <div class="col-lg-6 remove-padding review-item row">
              <div class="col-lg-6 item-title">Net operating income</div>
              <div class="col-lg-6 item-value">{{this.model.netoperatingIncome}}</div>
            </div>
            <div class="col-lg-6 remove-padding review-item row">
              <div class="col-lg-6 item-title">LTV</div>
              <div class="col-lg-6 item-value">{{this.model.LTV}}%</div>
            </div>
            <div class="col-lg-6 remove-padding review-item row">
              <div class="col-lg-6 item-title">DSCR</div>
              <div class="col-lg-6 item-value">{{this.model.DSCR}}</div>
            </div>
            <div class="col-lg-6 remove-padding review-item row">
              <div class="col-lg-6 item-title">Cap Rate</div>
              <div class="col-lg-6 item-value">{{this.model.CAPRate}}%</div>
            </div>
            <div class="col-lg-6 remove-padding review-item row">
              <div class="col-lg-6 item-title">Financing type</div>
              <div class="col-lg-6 item-value">{{this.model.financeType}}</div>
            </div>
            <div class="col-lg-6 remove-padding review-item row" :style="`display: ${model.financeType == 'PURCHASE' ? 'flex' : 'none'}`">
              <div class="col-lg-6 item-title">1031 exchange?</div>
              <div class="col-lg-6 item-value">{{this.model.is1031 ? 'Yes' : 'No'}}</div>
            </div>
            <div class="col-lg-6 remove-padding review-item row" :style="`display: ${model.financeType == 'PURCHASE' ? 'flex' : 'none'}`">
              <div class="col-lg-6 item-title">Current sales price</div>
              <div class="col-lg-6 item-value">{{this.model.currentSalesPrice}}</div>
            </div>
            <div class="col-lg-6 remove-padding review-item row" :style="`display: ${model.financeType == 'PURCHASE' ? 'flex' : 'none'}`">
              <div class="col-lg-6 item-title">Target closing date</div>
              <div class="col-lg-6 item-value">{{this.model.targetClosingDate}}</div>
            </div>
            <div class="col-lg-6 remove-padding review-item row" :style="`display: ${(model.financeType == 'RATE AND TERM REFINANCE' || model.financeType == 'CASH-OUT REFINANCE') ? 'flex' : 'none'}`">
              <div class="col-lg-6 item-title">Current loan balance</div>
              <div class="col-lg-6 item-value">{{this.model.currentLoanBalance}}</div>
            </div>
            <div class="col-lg-6 remove-padding review-item row" :style="`display: ${(model.financeType == 'RATE AND TERM REFINANCE' || model.financeType == 'CASH-OUT REFINANCE') ? 'flex' : 'none'}`">
              <div class="col-lg-6 item-title">Current rate</div>
              <div class="col-lg-6 item-value">{{this.model.currentRate}}%</div>
            </div>
            <div class="col-lg-6 remove-padding review-item row" :style="`display: ${(model.financeType == 'RATE AND TERM REFINANCE' || model.financeType == 'CASH-OUT REFINANCE') ? 'flex' : 'none'}`">
              <div class="col-lg-6 item-title">Loan maturity date</div>
              <div class="col-lg-6 item-value">{{this.model.loanMaturityDate}}</div>
            </div>
            <div class="col-lg-6 remove-padding review-item row" :style="`display: ${(model.financeType == 'RATE AND TERM REFINANCE' || model.financeType == 'CASH-OUT REFINANCE') ? 'flex' : 'none'}`">
              <div class="col-lg-6 item-title">Current lender</div>
              <div class="col-lg-6 item-value">{{this.model.currentLender}}</div>
            </div>
            <div class="col-lg-6 remove-padding review-item row" :style="`display: ${(model.financeType == 'RATE AND TERM REFINANCE' || model.financeType == 'CASH-OUT REFINANCE') ? 'flex' : 'none'}`">
              <div class="col-lg-6 item-title">Acquisition price</div>
              <div class="col-lg-6 item-value">{{this.model.acquisitionPrice}}</div>
            </div>
            <div class="col-lg-6 remove-padding review-item row" :style="`display: ${(model.financeType == 'RATE AND TERM REFINANCE' || model.financeType == 'CASH-OUT REFINANCE') ? 'flex' : 'none'}`">
              <div class="col-lg-6 item-title">Mo/Yr acquired</div>
              <div class="col-lg-6 item-value">{{this.model.MoYrAcquired}}</div>
            </div>
            <div class="col-lg-6 remove-padding review-item row" :style="`display: ${(model.financeType == 'RATE AND TERM REFINANCE' || model.financeType == 'CASH-OUT REFINANCE') ? 'flex' : 'none'}`">
              <div class="col-lg-6 item-title">Estimated cash-out available</div>
              <div class="col-lg-6 item-value">{{this.model.estimatedCashout}}</div>
            </div>
            <div class="col-lg-6 remove-padding review-item row" :style="`display: ${(model.financeType == 'PURCHASE' || model.cashoutUsage1 == '') ? 'none' : 'flex'}`">
              <div class="col-lg-6 item-title">Cash-out usage 1</div>
              <div class="col-lg-6 item-value">{{this.model.cashoutUsage1}}</div>
            </div>
            <div class="col-lg-6 remove-padding review-item row" :style="`display: ${(model.financeType == 'PURCHASE' || model.cashoutUsage1 == '') ? 'none' : 'flex'}`">
              <div class="col-lg-6 item-title">Cash-out amount 1</div>
              <div class="col-lg-6 item-value">{{this.model.cashoutAmount1}}</div>
            </div>
            <div class="col-lg-6 remove-padding review-item row" :style="`display: ${(model.financeType == 'PURCHASE' || model.cashoutUsage1 == '') ? 'none' : 'flex'}`">
              <div class="col-lg-6 item-title">Cash-out usage 2</div>
              <div class="col-lg-6 item-value">{{this.model.cashoutUsage2}}</div>
            </div>
            <div class="col-lg-6 remove-padding review-item row" :style="`display: ${(model.financeType == 'PURCHASE' || model.cashoutUsage1 == '') ? 'none' : 'flex'}`">
              <div class="col-lg-6 item-title">Cash-out amount 2</div>
              <div class="col-lg-6 item-value">{{this.model.cashoutAmount2}}</div>
            </div>
            <div class="col-lg-6 remove-padding review-item row" :style="`display: ${(model.financeType == 'PURCHASE' || model.cashoutUsage1 == '') ? 'none' : 'flex'}`">
              <div class="col-lg-6 item-title">Cash-out usage 3</div>
              <div class="col-lg-6 item-value">{{this.model.cashoutUsage3}}</div>
            </div>
            <div class="col-lg-6 remove-padding review-item row" :style="`display: ${(model.financeType == 'PURCHASE' || model.cashoutUsage1 == '') ? 'none' : 'flex'}`">
              <div class="col-lg-6 item-title">Cash-out amount 3</div>
              <div class="col-lg-6 item-value">{{this.model.cashoutAmount3}}</div>
            </div>
          </div>

          <div class="review-section col-lg-8 row">
            <div class="col-lg-6 remove-padding sub-title-margin"><h5 class="color-green">Owner Information</h5></div>
            <div class="col-lg-6 remove-padding sub-title-margin"><button class="edit-review uppercase" @click="editOwner()">Edit</button></div>
            <h6 class="col-lg-6 sub-title remove-padding">Future Owner</h6><div class="col-lg-6 remove-padding"></div>
            <div class="col-lg-6 remove-padding review-item row">
              <div class="col-lg-6 item-title">Name</div>
              <div class="col-lg-6 item-value">{{this.model.fullName}}</div>
            </div>
            <div class="col-lg-6 remove-padding review-item row">
              <div class="col-lg-6 item-title">Ownership</div>
              <div class="col-lg-6 item-value">{{this.model.ownership}}%</div>
            </div>
            <div class="col-lg-6 remove-padding review-item row">
              <div class="col-lg-6 item-title">Liquidity</div>
              <div class="col-lg-6 item-value">{{this.model.liquidity}}</div>
            </div>
            <div class="col-lg-6 remove-padding review-item row">
              <div class="col-lg-6 item-title">Credit score</div>
              <div class="col-lg-6 item-value">{{this.model.creditScore}}</div>
            </div>
            <div class="col-lg-6 remove-padding review-item row">
              <div class="col-lg-6 item-title">Net worth</div>
              <div class="col-lg-6 item-value">{{this.model.netWorth}}</div>
            </div>
            <div class="col-lg-6 remove-padding review-item row">
              <div class="col-lg-6 item-title">Date of birth/Founding date</div>
              <div class="col-lg-6 item-value">{{this.model.DOBorFoundingDate}}</div>
            </div>
            <div class="col-lg-6 remove-padding review-item row">
              <div class="col-lg-6 item-title">SSN/EIN</div>
              <div class="col-lg-6 item-value">{{this.model.SSNorEIN}}</div>
            </div>
            <div class="col-lg-6 remove-padding review-item row">
              <div class="col-lg-6 item-title">Address</div>
              <div class="col-lg-6 item-value">{{this.model.fullAddress}}</div>
            </div>
            <div class="col-lg-6 remove-padding review-item row">
              <div class="col-lg-6 item-title">Owns residence?</div>
              <div class="col-lg-6 item-value">{{this.model.ownResidence}}</div>
            </div>
            <div class="col-lg-6 remove-padding"></div>
            <h6 class="col-lg-6 sub-title remove-padding" style="padding-top:20px;">Special Situation</h6><div class="col-lg-6 remove-padding"></div>
            <div class="col-lg-6 remove-padding review-item row">
              <div class="col-lg-6 item-title">Had a property foreclosed in last 3 years?</div>
              <div class="col-lg-6 item-value">{{this.model.anyPropertyForeclosed}}</div>
            </div>
            <div class="col-lg-6 remove-padding review-item row">
              <div class="col-lg-6 item-title">Filed for bankruptcy in last 5 years?</div>
              <div class="col-lg-6 item-value">{{this.model.anyFiledBankruptcy}}</div>
            </div>
            <div class="col-lg-6 remove-padding review-item row">
              <div class="col-lg-6 item-title">Missed mortgage payments in last 12 months?</div>
              <div class="col-lg-6 item-value">{{this.model.anyMissedMortgage}}</div>
            </div>
            <div class="col-lg-6 remove-padding review-item row">
              <div class="col-lg-6 item-title">Failed to file federal tax returns for last 3 years?</div>
              <div class="col-lg-6 item-value">{{this.model.anyFailedFederalTaxReturn}}</div>
            </div>
            <div class="col-lg-6 remove-padding review-item row">
              <div class="col-lg-6 item-title">Are an borrowers or guarantors a foreign national?</div>
              <div class="col-lg-6 item-value">{{this.model.anyForeignNational}}</div>
            </div>
            <div class="col-lg-6 remove-padding review-item row">
              <div class="col-lg-6 item-title">Are there back real estate taxes owed on subject property?</div>
              <div class="col-lg-6 item-value">{{this.model.anyRealEstateTaxOwed}}</div>
            </div>
          </div>
          <div class="review-section col-lg-8 row">
            <div class="col-lg-6 remove-padding sub-title-margin"><h5 class="color-green">Contact Information</h5></div>
            <div class="col-lg-6 remove-padding sub-title-margin"><button class="edit-review uppercase" @click="editOwner()">Edit</button></div>
            <div class="col-lg-6 remove-padding review-item row">
              <div class="col-lg-6 item-title">First Name</div>
              <div class="col-lg-6 item-value">{{this.model.firstName}}</div>
            </div>
            <div class="col-lg-6 remove-padding review-item row">
              <div class="col-lg-6 item-title">Last Name</div>
              <div class="col-lg-6 item-value">{{this.model.lastName}}</div>
            </div>
            <div class="col-lg-6 remove-padding review-item row">
              <div class="col-lg-6 item-title">Email Address</div>
              <div class="col-lg-6 item-value">{{this.model.personalEmail}}</div>
            </div>
            <div class="col-lg-6 remove-padding review-item row">
              <div class="col-lg-6 item-title">Mobile Phone</div>
              <div class="col-lg-6 item-value">{{this.model.personalPhone}}</div>
            </div>
          </div>
          <div class="review-section col-lg-8 row">
            <div class="col-lg-6 remove-padding sub-title-margin"><h5 class="color-green">Required Documents</h5></div>
            <div class="col-lg-12">
              <ul class="amcredit-document-list">
                <li>Current rent roll</li>
                <li>Property operating statements – Last two years and YTD</li>
                <li>Purchase contract – (If the loan is for the purchase of property)</li>
                <li>Mortgage Statement – (If the loan is a refinance of property)</li>
                <li>Tax returns – Last two years tax returns (If property is owner occupied)</li>
                <li>Current lease with Tenant information – (If occupied)</li>
                <li>FNMA 1003 form – (If complete and available)</li>
                <li>Any detailed Letter of Explanation</li>
              </ul>
            </div>
            <div class="amcredit-text">Upload the above required documents, files must be PDF, JPEG, PNG, DOC or XLS, 25mb max.</div>
            <div class="amcredit-text">Please upload any documents available now. You can always come back to upload additional documents. Underwriting starts only when all the required documents are in place.</div>
            <!-- <div class="amcredit-text">Not sure what documents to upload? Visit <a href="https://amcredit.com/blog/amcredit-loan-submission-documents/" target="_blank">American Credit® Loan Submission Documents</a> to check out the list.</div> -->
            <div class="remove-padding col-lg-12">
              <multiple-uploads @ready="childVal => { uploadedFiles = childVal }" />
            </div>
          </div>

          <div class="review-section col-lg-8 row">
            <div class="col-lg-6 remove-padding sub-title-margin"><h5 class="color-green">Comments (optional)</h5></div>
            <div class="remove-padding col-lg-12">
              <textarea v-model="brokerNote" name="application-notes" id="application-notes" cols="30" rows="4"></textarea>
            </div>
          </div>

        </tab-content>
    </form-wizard>

    <div class="reveal-overlay" :style="`display: ${model.displayPromoCode ? 'block' : 'none'}`">
      <div id="contact-modal" data-reveal="2ocrej-reveal" class="reveal small" role="dialog" aria-hidden="false" data-yeti-box="contact-modal" data-resize="contact-modal" data-events="resize" tabindex="-1" style="top: 41px; display: block;">
        <button data-close="" aria-label="Close modal" type="button" class="close-button" @click="model.displayPromoCode = false">
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M7.99809 8.70715L11.6445 12.3536L12.3516 11.6465L8.70519 8.00004L12.3516 4.35359L11.6445 3.64648L7.99809 7.29293L4.35164 3.64648L3.64453 4.35359L7.29098 8.00004L3.64453 11.6465L4.35164 12.3536L7.99809 8.70715Z" fill="#787D78"></path></svg>
        </button> 
        <h4>Promotion code applied successfully!</h4> 
        <div class="intro color-gray ls-n-p-1 f-w-400">Your promotion code <strong>{{this.model.promoCode}}</strong> has been applied successfully. Once your loan is successfully funded, you will receive $100 cash rebate.</div> 
        <hr>
        <div class="text-right"><button data-close="" class="button" @click="model.displayPromoCode = false">OK</button></div>
      </div>
    </div>

    <div class="reveal-overlay" :style="`display: ${displayContactYou ? 'block' : 'none'}`">
      <div id="contact-modal" data-reveal="2ocrej-reveal" class="reveal small" role="dialog" aria-hidden="false" data-yeti-box="contact-modal" data-resize="contact-modal" data-events="resize" tabindex="-1" style="top: 41px; display: block;">
        <button data-close="" aria-label="Close modal" type="button" class="close-button" @click="displayContactYou = false">
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M7.99809 8.70715L11.6445 12.3536L12.3516 11.6465L8.70519 8.00004L12.3516 4.35359L11.6445 3.64648L7.99809 7.29293L4.35164 3.64648L3.64453 4.35359L7.29098 8.00004L3.64453 11.6465L4.35164 12.3536L7.99809 8.70715Z" fill="#787D78"></path></svg>
        </button> 
        <h4>Consent for American Credit to Contact You</h4> 
        <div class="intro color-gray ls-n-p-1 f-w-400">I hereby confirm that by providing American Credit and its assignees, partners, lenders, or funding service (“Assignees”) with an email address or telephone number, including for a wireless device, I have obtained and am authorized to provide, the necessary express consent from each Company Owner, and that by submitting this Application, I expressly consent on behalf of each Company Owner to communications including email, voice and text messages from, or on behalf of, American Credit and its Assignees, regardless of their purpose, including but not limited to marketing or collection purposes. 
          I understand and agree that: (i) these calls and messages may be subject to charges from an internet or wireless provider; (ii) this consent is not a condition of doing business with, or making a purchase of any goods/services from, American Credit and its Assignees; and (iii) any Company Owner may unsubscribe or opt-out of any further telemarketing calls or marketing text messages at any time.</div> 
        <hr>
        <div class="text-right"><button data-close="" class="button" @click="displayContactYou = false">OK</button></div>
      </div>
    </div>

    <div class="reveal-overlay" :style="`display: ${displayCreditReport ? 'block' : 'none'}`">
      <div id="contact-modal" data-reveal="2ocrej-reveal" class="reveal small" role="dialog" aria-hidden="false" data-yeti-box="contact-modal" data-resize="contact-modal" data-events="resize" tabindex="-1" style="top: 41px; display: block;">
        <button data-close="" aria-label="Close modal" type="button" class="close-button" @click="displayCreditReport = false">
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M7.99809 8.70715L11.6445 12.3536L12.3516 11.6465L8.70519 8.00004L12.3516 4.35359L11.6445 3.64648L7.99809 7.29293L4.35164 3.64648L3.64453 4.35359L7.29098 8.00004L3.64453 11.6465L4.35164 12.3536L7.99809 8.70715Z" fill="#787D78"></path></svg>
        </button> 
        <h4>Consent for American Credit to Obtain a Credit Report</h4> 
        <div class="intro color-gray ls-n-p-1 f-w-400">I hereby confirm that each Company Owner of the Company provided in this Application (i) is aware of the Company's request for financing; (ii) may be required to guaranty the requested financing; and (iii) have authorized American Credit, its assignees, partners, lenders, or funding service (“Assignees”) to obtain their respective consumer or business credit reports, as well as use this application and all supporting documentation, now and from time to time, in the credit application and review process.<br><br>
        By selecting ‘I agree’, I am authorized to, and hereby permit, American Credit and its Assignees to obtain (i) a consumer credit report on each Company Owner for credit purposes & further authorize the release to American Credit and its Assignees of all credit information it may request, including business & personal banking, mortgage, landlord, trade & lease information related to each of them; and (ii) confirm that each Company Owner of the company has provided the Credit Consent.</div> 
        <hr>
        <div class="text-right"><button data-close="" class="button" @click="displayCreditReport = false">OK</button></div>
      </div>
    </div>
  </div>
  
</template>

<script>
// import Vue from 'vue'
import { mapGetters, mapActions, mapMutations } from "vuex";
import { Loading } from "element-ui";
import * as types from "../vuex/types";
import VueFormGenerator from 'vue-form-generator'
import MultipleUploads from './applyLoan/MultipleUploads.vue'
// import 'vue-form-generator/dist/vfg.css'
import api from "../vuex/api/index";
import axios from 'axios';
import Cleave from 'cleave.js';
import moment from 'moment';
import { validators } from "vue-form-generator";

// Vue.use(VueFormGenerator)

export default {
  name: "ApplyForm",
  components: {
    "vue-form-generator": VueFormGenerator.component,
    MultipleUploads
	},
  data () {
    return {
      owner2Toggle: true,
      numOfOwner: 1,
      showOwner2: false,
      showOwner3: false,
      showOwner4: false,
      displayCreditReport: false,
      displayContactYou: false,
      uploadedFiles: null,
      addOwners:[],
      consentToggle: false,
      toggle: true,
      brokerNote: '',
      submittedAlready: false,
      model:{
        promoCode: '',
        displayPromoCode: false,
        loanTerm: '',
        customerType: '1',
        equipmentDescription:'',
        equipmentStatus:'',
        equipmentCost:'',
        downPayment:'',
        isPurchase: -1,
        downPaymentAmount:'',
        companyName:'',
        FederalID:'',
        address:'',
        address2:'',
        city:'',
        state:null,
        zip:'',
        buildingSqft:'',
        numberOfUnits:'',
        percentOccupied:'',
        ownerOccupied:null,
        ownerOccupiedSqft:'',
        propertyType:null,
        propertyStyle:null,
        propertyHave:[],
        loanAmount:'',
        desiredRate:'',
        amortizationInMonths:'',
        YSPRebate:'',
        currentEstimatedValue:'',
        monthlyPmt:'',
        annualPmt:'',
        annualGrossIncome:'',
        annualOperatingExpense:'',
        netoperatingIncome:'',
        LTV:'',
        DSCR:'',
        CAPRate:'',
        financeType:null,
        is1031:null,
        currentSalesPrice:'',
        targetClosingDate:'',
        currentLoanBalance:'',
        currentRate:'',
        loanMaturityDate:'',
        currentLender:'',
        acquisitionPrice:'',
        MoYrAcquired:'',
        estimatedCashout:'',
        cashoutUsage1:'',
        cashoutAmount1:'',
        cashoutUsage2:'',
        cashoutAmount2:'',
        cashoutUsage3:'',
        cashoutAmount3:'',
        fullName:'',
        creditScore:'',
        DOBorFoundingDate:'',
        SSNorEIN:'',
        fullAddress:'',
        ownResidence: null,
        ownership:'',
        liquidity:'',
        netWorth:'',
        owner2Name:'',
        owner2CreditScore:'',
        owner2DOBorFoundingDate:'',
        owner2SSNorEIN:'',
        owner2FullAddress:'',
        owner2OwnResidence:null,
        owner2Ownership:'',
        owner2Liquidity:'',
        owner2NetWorth:'',
        owner3Name:'',
        owner3CreditScore:'',
        owner3DOBorFoundingDate:'',
        owner3SSNorEIN:'',
        owner3FullAddress:'',
        owner3OwnResidence:null,
        owner3Ownership:'',
        owner3Liquidity:'',
        owner3NetWorth:'',
        owner4Name:'',
        owner4CreditScore:'',
        owner4DOBorFoundingDate:'',
        owner4SSNorEIN:'',
        owner4FullAddress:'',
        owner4OwnResidence:null,
        owner4Ownership:'',
        owner4Liquidity:'',
        owner4NetWorth:'',
        anyPropertyForeclosed: null,
        anyFiledBankruptcy: null,
        anyMissedMortgage: null,
        anyFailedFederalTaxReturn: null,
        anyForeignNational: null,
        anyRealEstateTaxOwed: null,

        companyEmail:'',
        companyPhone:'',
        stateOfIncorporation:null,
        yearsInBusiness:'',
        businessDescription:null,
        reasonForEquipment:null,
        taxClassification:null,
        firstName:'',
        lastName:'',
        ssn:'',
        ownership:'',
        personalEmail:'',
        personalPhone:'',
        ownerAddress:'',
        ownerAddress2:'',
        ownerCity:'',
        ownerState:null,
        ownerZip:'',
        owner2FirstName:'',
        owner2LastName:'',
        owner2Ssn:'',
        owner2Ownership:'',
        owner2PersonalEmail:'',
        owner2PersonalPhone:'',
        owner2Address:'',
        owner2Address2:'',
        owner2City:'',
        owner2State:null,
        owner2Zip:''
      },
   formOptions: {
    validationErrorClass: "has-error",
    validationSuccessClass: "has-success",
    validateAfterChanged: true
   },
   firstTabSchema:{
     fields:[
      {
          type: "input",
          inputType: "text",
          label: "Property Information",
          placeholder: "Address",
          model: "address",
          required: true,
          validator: ["string", "required"],
          styleClasses: 'col-lg-8 custom-input custom-lg-8 input-label-placeholder input-top-placeholder'
      },
      {
          type: "input",
          inputType: "text",
          placeholder: "Address Line 2",
          model: "address2",
          validator: VueFormGenerator.validators.string,
          styleClasses: 'col-lg-8 custom-input custom-lg-8 input-top-placeholder'
      },
      {
          type: "input",
          inputType: "text",
          placeholder: "City",
          model: "city",
          required: true,
          validator: VueFormGenerator.validators.string,
          styleClasses: 'col-lg-4 custom-input input-top-placeholder'
      },
      {
          type: 'select',
          placeholder: 'State',
          model: 'state',
          required: true,
          validator: "required",
          values: ['Alabama','Alaska','Arizona','Arkansas','California','Colorado','Connecticut','Delaware','Florida','Georgia','Hawaii','Idaho','Illinois','Indiana','Iowa','Kansas','Kentucky','Louisiana','Maine','Maryland','Massachusetts','Michigan','Minnesota','Mississippi','Missouri','Montana','Nebraska','Nevada','New Hampshire','New Jersey','New Mexico','New York','North Carolina','North Dakota','Ohio','Oklahoma','Oregon','Pennsylvania','Rhode Island','South Carolina','South Dakota','Tennessee','Texas','Utah','Vermont','Virginia','Washington','West Virginia','Wisconsin','Wyoming'],
          selectOptions: {
            noneSelectedText: "State"
          },
          styleClasses:'col-lg-4 custom-input select-top-placeholder',
          onChanged: function(model, newVal, oldVal, field) {
            field.styleClasses = field.styleClasses + ' selected';
          }
      },
      {
        type: "cleave",
				inputType: "text",
        model: "zip",
        placeholder: "Zip",
        required:true,
        min: 5,
        validator: validators.string.locale({
          fieldIsRequired: "This field is required!",
          textTooSmall: "Please input a valid zip."
        }),
        cleaveOptions: {
          blocks: [5],
          numericOnly: true
        },
        styleClasses:'col-lg-4 custom-input input-top-placeholder'
      },
      {
       type: 'cleave',
       inputType: 'number',
       model: "buildingSqft",
       placeholder: 'Building sq. ft',
       required:true,
       validator: VueFormGenerator.validators.string,
       cleaveOptions: {
         numeral: true,
         numeralThousandsGroupStyle: 'thousand',
         delimiter: ','
       },
       styleClasses:'col-lg-4 custom-input input-top-placeholder'
     },
     {
       type: 'input',
       inputType: 'number',
       model: "numberOfUnits",
       placeholder: 'Number of units',
       required:true,
       validator: VueFormGenerator.validators.integer,
       styleClasses:'col-lg-4 custom-input input-top-placeholder'
     },
     {
       type: 'input',
       inputType: 'number',
       model: "percentOccupied",
       placeholder: 'Percent occupied %',
       required:true,
       validator: VueFormGenerator.validators.number,
       min: 0,
       max: 100,
       styleClasses:'col-lg-4 custom-input input-top-placeholder'
     },
     {
        type: 'radios',
        label: 'Does the owner occupy any portion of the building?',
        model: 'ownerOccupied',
        values:[
          {
            name: "Yes",
            value: true
          },
          {
            name: "No",
            value: false
          }
        ],
        required: true,
        validator: "required",
        styleClasses:'col-lg-4 input-type-radio'
     },{
        type: "cleave",
				inputType: "number",
        label: "If yes, how many sq. ft.?",
        model: "ownerOccupiedSqft",
        required: true,
        validator: VueFormGenerator.validators.string,
        cleaveOptions: {
          numeral: true,
          numeralThousandsGroupStyle: 'thousand',
          delimiter: ','
        },
        styleClasses:'col-lg-8 custom-lg-8 input-type-number',
        visible(model) {
            return model && model.ownerOccupied;
        }
     },
     {
        type: 'select',
        placeholder: 'Property type',
        model: 'propertyType',
        values: ['Multifamily', 'Retail', 'Mixed-use', 'Industrial', 'Office', 'Self-storage', 'Mobile home park', 'Single family pool (5+ units) (Core Program Only)'],
        required:true,
        validator: "required",
        styleClasses:'col-lg-4 custom-input select-top-placeholder',
        selectOptions: {
          noneSelectedText: "Property type"
        },
        onChanged: function(model, newVal, oldVal, field) {
          field.styleClasses = field.styleClasses + ' selected';
        }
     },
     {
        type: 'select',
        placeholder: 'Property style',
        model: 'propertyStyle',
        values: ['SFR', 'Condo/Townhome', 'Duplex', 'Triplex', 'Fourplex'],
        required:true,
        validator: "required",
        styleClasses:'col-lg-4 custom-input select-top-placeholder',
        selectOptions: {
          noneSelectedText: "Property style"
        },
        onChanged: function(model, newVal, oldVal, field) {
          field.styleClasses = field.styleClasses + ' selected';
        }
     },
     {
        type: 'checklist',
        label: 'Select all options apply to the property',
        model: 'propertyHave',
        values: ['Underground or above-ground storage tanks', 'Automotive repair uses', 'Ongoing environmental remediation', 'Hazardous material handling/licensing', 'On-site dry cleaner plant', 'A prior Phase 1 report available', 'None of the above applies'],
        multi: true,
        required: true,
        multiSelect: true,
        styleClasses: 'col-lg-8'
      },
     {
       type: 'cleave',
       inputType: 'number',
       label: "Loan Information",
       model: "loanAmount",
       placeholder: 'Loan amount requested',
       required:true,
       validator: VueFormGenerator.validators.string,
       cleaveOptions: {
         numeral: true,
         prefix: '$',
         numeralThousandsGroupStyle: 'thousand',
         delimiter: ',',
         noImmediatePrefix: true
       },
       styleClasses:'col-lg-8 custom-input input-label-placeholder input-top-placeholder'
     },
     {
       type: 'input',
       inputType: 'number',
       model: "desiredRate",
       placeholder: 'Desired rate %',
       required:true,
       validator: VueFormGenerator.validators.number,
       min: 0,
       max: 100,
       styleClasses:'col-lg-4 custom-input input-top-placeholder'
     },
     {
       type: 'input',
       inputType: 'number',
       model: "amortizationInMonths",
       placeholder: 'Amortization in months',
       required:true,
       validator: VueFormGenerator.validators.integer,
       styleClasses:'col-lg-4 custom-input input-top-placeholder'
     },
     {
       type: 'input',
       inputType: 'number',
       model: "YSPRebate",
       placeholder: 'Yield spread premium (YSP) rebate %',
       required:true,
       validator: VueFormGenerator.validators.number,
       min: 0,
       max: 100,
       styleClasses:'col-lg-4 custom-input input-top-placeholder'
     },
     {
       type: 'cleave',
       inputType: 'number',
       model: "currentEstimatedValue",
       placeholder: 'Current estimated value',
       required:true,
       validator: VueFormGenerator.validators.string,
       cleaveOptions: {
         numeral: true,
         prefix: '$',
         numeralThousandsGroupStyle: 'thousand',
         delimiter: ',',
         noImmediatePrefix: true
       },
       styleClasses:'col-lg-4 custom-input input-top-placeholder'
     },
     {
       type: 'cleave',
       inputType: 'number',
       model: "monthlyPmt",
       placeholder: 'Monthly pmt',
       required:true,
       validator: VueFormGenerator.validators.string,
       cleaveOptions: {
         numeral: true,
         prefix: '$',
         numeralThousandsGroupStyle: 'thousand',
         delimiter: ',',
         noImmediatePrefix: true
       },
       styleClasses:'col-lg-4 custom-input input-top-placeholder'
     },
     {
       type: 'cleave',
       inputType: 'number',
       model: "annualPmt",
       placeholder: 'Annual pmt',
       required:true,
       validator: VueFormGenerator.validators.string,
       cleaveOptions: {
         numeral: true,
         prefix: '$',
         numeralThousandsGroupStyle: 'thousand',
         delimiter: ',',
         noImmediatePrefix: true
       },
       styleClasses:'col-lg-4 custom-input input-top-placeholder'
     },
     {
       type: 'cleave',
       inputType: 'number',
       model: "annualGrossIncome",
       placeholder: 'Annual gross income',
       required:true,
       validator: VueFormGenerator.validators.string,
       cleaveOptions: {
         numeral: true,
         prefix: '$',
         numeralThousandsGroupStyle: 'thousand',
         delimiter: ',',
         noImmediatePrefix: true
       },
       styleClasses:'col-lg-4 custom-input input-top-placeholder'
     },
     {
       type: 'cleave',
       inputType: 'number',
       model: "annualOperatingExpense",
       placeholder: 'Annual operating expense',
       required:true,
       validator: VueFormGenerator.validators.string,
       cleaveOptions: {
         numeral: true,
         prefix: '$',
         numeralThousandsGroupStyle: 'thousand',
         delimiter: ',',
         noImmediatePrefix: true
       },
       styleClasses:'col-lg-4 custom-input input-top-placeholder'
     },
     {
       type: 'cleave',
       inputType: 'number',
       model: "netoperatingIncome",
       placeholder: 'Net operating income',
       required:true,
       validator: VueFormGenerator.validators.string,
       cleaveOptions: {
         numeral: true,
         prefix: '$',
         numeralThousandsGroupStyle: 'thousand',
         delimiter: ',',
         noImmediatePrefix: true
       },
       styleClasses:'col-lg-4 custom-input input-top-placeholder'
     },
     {
       type: 'input',
       inputType: 'number',
       model: "LTV",
       placeholder: 'Loan-to-value (LTV) %',
       required:true,
       validator: VueFormGenerator.validators.number,
       min: 0,
       max: 100,
       styleClasses:'col-lg-4 custom-input input-top-placeholder'
     },
     {
       type: 'input',
       inputType: 'number',
       model: "DSCR",
       placeholder: 'Debt-service coverage ratio (DSCR)',
       required:true,
       validator: VueFormGenerator.validators.number,
       styleClasses:'col-lg-4 custom-input input-top-placeholder'
     },
     {
       type: 'input',
       inputType: 'number',
       model: "CAPRate",
       placeholder: 'Cap rate %',
       required:true,
       validator: VueFormGenerator.validators.number,
       min: 0,
       max: 100,
       styleClasses:'col-lg-4 custom-input input-top-placeholder'
     },
     {
        type: 'radios',
        label: 'Choose the financing type you are applying for',
        model: 'financeType',
        values:[
          {
            name: "PURCHASE",
            value: "PURCHASE"
          },
          {
            name: "RATE AND TERM REFINANCE",
            value: "RATE AND TERM REFINANCE"
          },
          {
            name: "CASH-OUT REFINANCE",
            value: "CASH-OUT REFINANCE"
          }
        ],
        required: true,
        validator: "required",
        styleClasses:'col-lg-8 input-type-radio financing-type-radio'
     }]
   },
   purchaseSchema: {
     fields:[
       {
        type: 'radios',
        label: '1031 exchange?',
        model: 'is1031',
        values:[
          {
            name: "Yes",
            value: true
          },
          {
            name: "No",
            value: false
          }
        ],
        required: true,
        validator: "required",
        styleClasses:'col-lg-4 input-type-radio'
     },
     {
       type: 'cleave',
       inputType: 'number',
       model: "currentSalesPrice",
       placeholder: 'Current sales price',
       required:true,
       validator: VueFormGenerator.validators.string,
       cleaveOptions: {
         numeral: true,
         prefix: '$',
         numeralThousandsGroupStyle: 'thousand',
         delimiter: ',',
         noImmediatePrefix: true
       },
       styleClasses:'col-lg-4 custom-input input-top-placeholder'
     },
     {
        type: 'cleave',
        inputType: 'text',
        model: "targetClosingDate",
        placeholder: 'Target closing date [MM/DD/YYYY]',
        required:true,
        min: 10,
        validator: [validators.string.locale({
          fieldIsRequired: "This field is required!",
          textTooSmall: "Date format: MM/DD/YYYY."
        }), 'checkDateValid'],
        cleaveOptions: {
          blocks: [2, 2, 4],
          delimiters: ["/", "/"],
          numericOnly: true
        },
        styleClasses:'col-lg-4 custom-input input-top-placeholder'
     }]
   },
   refinanceSchema: {
     fields:[
       {
       type: 'cleave',
       inputType: 'number',
       model: "currentLoanBalance",
       placeholder: 'Current loan balance',
       required:true,
       cleaveOptions: {
         numeral: true,
         prefix: '$',
         numeralThousandsGroupStyle: 'thousand',
         delimiter: ',',
         noImmediatePrefix: true
       },
       styleClasses:'col-lg-4 custom-input input-top-placeholder'
     },{
       type: 'input',
       inputType: 'number',
       model: "currentRate",
       placeholder: 'Current rate %',
       required:true,
       validator: VueFormGenerator.validators.number,
       min: 0,
       max: 100,
       styleClasses:'col-lg-4 custom-input input-top-placeholder'
     },{
       type: 'cleave',
       inputType: 'text',
       model: "loanMaturityDate",
       placeholder: 'Loan maturity date [MM/DD/YYYY]',
       required:true,
       min: 10,
        validator: [validators.string.locale({
          fieldIsRequired: "This field is required!",
          textTooSmall: "Date format: MM/DD/YYYY."
        }), 'checkDateValid'],
        cleaveOptions: {
          blocks: [2, 2, 4],
          delimiters: ["/", "/"],
          numericOnly: true
        },
       styleClasses:'col-lg-4 custom-input input-top-placeholder'
     },{
       type: 'input',
       inputType: 'text',
       model: "currentLender",
       placeholder: 'Current lender',
       required:true,
       validator: "required",
       styleClasses:'col-lg-4 custom-input input-top-placeholder'
     },{
       type: 'cleave',
       inputType: 'number',
       model: "acquisitionPrice",
       placeholder: 'Acquisition price',
       required:true,
       validator: VueFormGenerator.validators.string,
       cleaveOptions: {
         numeral: true,
         prefix: '$',
         numeralThousandsGroupStyle: 'thousand',
         delimiter: ',',
         noImmediatePrefix: true
       },
       styleClasses:'col-lg-4 custom-input input-top-placeholder'
     },{
       type: 'cleave',
       inputType: 'text',
       model: "MoYrAcquired",
       placeholder: 'Mo/Yr acquired [MM/YYYY]',
       required:true,
       min: 7,
        validator: validators.string.locale({
          fieldIsRequired: "This field is required!",
          textTooSmall: "Date format: MM/YYYY."
        }),
        cleaveOptions: {
          blocks: [2, 4],
          delimiters: ["/"],
          numericOnly: true
        },
       styleClasses:'col-lg-4 custom-input input-top-placeholder'
     },{
       type: 'cleave',
       inputType: 'number',
      //  label: "If cash-out, please state what the funds will be used for and amount",
       model: "estimatedCashout",
       placeholder: 'Estimated cash-out available',
       required:true,
       validator: VueFormGenerator.validators.string,
       cleaveOptions: {
         numeral: true,
         prefix: '$',
         numeralThousandsGroupStyle: 'thousand',
         delimiter: ',',
         noImmediatePrefix: true
       },
       styleClasses:'col-lg-8 custom-input input-top-placeholder'
     },
     {
       type: 'input',
       inputType: 'text',
       model: "cashoutUsage1",
       placeholder: 'Cash-out usage 1',
      //  required:true,
      //  validator: "required",
       styleClasses:'col-lg-4 custom-input input-top-placeholder'
     },{
       type: 'cleave',
       inputType: 'number',
       model: "cashoutAmount1",
       placeholder: 'Cash-out amount 1',
      //  required:true,
      //  validator: "required",
       cleaveOptions: {
         numeral: true,
         prefix: '$',
         numeralThousandsGroupStyle: 'thousand',
         delimiter: ',',
         noImmediatePrefix: true
       },
       styleClasses:'col-lg-4 custom-input input-top-placeholder'
     },
     {
       type: 'input',
       inputType: 'text',
       model: "cashoutUsage2",
       placeholder: 'Cash-out usage 2',
      //  required:true,
      //  validator: "required",
       styleClasses:'col-lg-4 custom-input input-top-placeholder'
     },{
       type: 'cleave',
       inputType: 'number',
       model: "cashoutAmount2",
       placeholder: 'Cash-out amount 2',
      //  required:true,
      //  validator: "required",
       cleaveOptions: {
         numeral: true,
         prefix: '$',
         numeralThousandsGroupStyle: 'thousand',
         delimiter: ',',
         noImmediatePrefix: true
       },
       styleClasses:'col-lg-4 custom-input input-top-placeholder'
     },
     {
       type: 'input',
       inputType: 'text',
       model: "cashoutUsage3",
       placeholder: 'Cash-out usage 3',
      //  required:true,
      //  validator: "required",
       styleClasses:'col-lg-4 custom-input input-top-placeholder'
     },{
       type: 'cleave',
       inputType: 'number',
       model: "cashoutAmount3",
       placeholder: 'Cash-out amount 3',
      //  required:true,
      //  validator: "required",
       cleaveOptions: {
         numeral: true,
         prefix: '$',
         numeralThousandsGroupStyle: 'thousand',
         delimiter: ',',
         noImmediatePrefix: true
       },
       styleClasses:'col-lg-4 custom-input input-top-placeholder'
     }]
   },
   secondTabSchema:{
     fields:[
      {
        type: "input",
        inputType: "text",
        placeholder: "Person/Entity Full Name",
        model: "fullName",
        required:true,
        validator:VueFormGenerator.validators.string,
        styleClasses:'col-lg-4 custom-input input-top-placeholder'
     },
     {
        type: "input",
				inputType: "number",
        placeholder: "% of ownership",
        model: "ownership",
        required:true,
        validator: ['required', 'integer'],
        min: 1,
        max: 100,
        styleClasses:'col-lg-4 custom-input input-top-placeholder'
     },
     {
        type: 'cleave',
        inputType: 'text',
        model: "DOBorFoundingDate",
        placeholder: 'Date of birth/Founding date [MM/DD/YYYY]',
        required:true,
        min: 10,
        validator: [validators.string.locale({
          fieldIsRequired: "This field is required!",
          textTooSmall: "Date format: MM/DD/YYYY."
        }), 'checkDateValid'],
        cleaveOptions: {
          blocks: [2, 2, 4],
          delimiters: ["/", "/"],
          numericOnly: true
        },
        styleClasses:'col-lg-4 custom-input input-top-placeholder'
     },
     {
        type: "cleave",
        inputType: "text",
        placeholder: "SSN/EIN",
        model: "SSNorEIN",
        required:true,
        min: 9,
        validator: validators.string.locale({
          fieldIsRequired: "This field is required!",
          textTooSmall: "Please input a valid SSN/EIN."
        }),
        cleaveOptions: {
          blocks: [9],
          numericOnly: true
        },
        styleClasses:'col-lg-4 custom-input input-top-placeholder'
     },
     {
        type: "input",
				inputType: "text",
        placeholder: "Full Address",
        model: "fullAddress",
        required:true,
        validator:VueFormGenerator.validators.string,
        styleClasses:'col-lg-8 custom-input custom-lg-8 input-top-placeholder'
     },
     {
        type: 'select',
        placeholder: 'Owns residence?',
        model: 'ownResidence',
        required:true,
        validator: "required",
        values: ['Yes','No'],
        styleClasses:'col-lg-4 custom-input select-top-placeholder',
        selectOptions: {
          noneSelectedText: "Owns residence?"
        },
        onChanged: function(model, newVal, oldVal, field) {
          field.styleClasses = field.styleClasses + ' selected';
        }
     },
     {
       type: 'input',
       inputType: 'number',
       model: "creditScore",
       placeholder: 'Credit score',
       required:true,
       validator: VueFormGenerator.validators.integer,
       styleClasses:'col-lg-4 custom-input input-top-placeholder'
     },
     {
       type: 'cleave',
       inputType: 'number',
       model: "liquidity",
       placeholder: 'Liquidity',
       required:true,
       validator: VueFormGenerator.validators.string,
       cleaveOptions: {
         numeral: true,
         prefix: '$',
         numeralThousandsGroupStyle: 'thousand',
         delimiter: ',',
         noImmediatePrefix: true
       },
       styleClasses:'col-lg-4 custom-input input-top-placeholder'
     },   
     {
       type: 'cleave',
       inputType: 'number',
       model: "netWorth",
       placeholder: 'Net worth',
       required:true,
       validator: VueFormGenerator.validators.string,
       cleaveOptions: {
         numeral: true,
         prefix: '$',
         numeralThousandsGroupStyle: 'thousand',
         delimiter: ',',
         noImmediatePrefix: true
       },
       styleClasses:'col-lg-4 custom-input input-top-placeholder'
     }]
   },
   addOwnerSchema2: {
     fields:[
      {
        type: "input",
        inputType: "text",
        placeholder: "Person/Entity Full Name",
        model: "owner2Name",
        required:true,
        validator:VueFormGenerator.validators.string,
        styleClasses:'col-lg-4 custom-input input-top-placeholder'
     },
     {
        type: "input",
				inputType: "number",
        placeholder: "% of ownership",
        model: "owner2Ownership",
        required:true,
        validator: ['required', 'integer'],
        min: 1,
        max: 100,
        styleClasses:'col-lg-4 custom-input input-top-placeholder'
     },
     {
        type: 'cleave',
        inputType: 'text',
        model: "owner2DOBorFoundingDate",
        placeholder: 'Date of birth/Founding date [MM/DD/YYYY]',
        required:true,
        min: 10,
        validator: [validators.string.locale({
          fieldIsRequired: "This field is required!",
          textTooSmall: "Date format: MM/DD/YYYY."
        }), 'checkDateValid'],
        cleaveOptions: {
          blocks: [2, 2, 4],
          delimiters: ["/", "/"],
          numericOnly: true
        },
        styleClasses:'col-lg-4 custom-input input-top-placeholder'
     },
     {
        type: "cleave",
        inputType: "text",
        placeholder: "SSN/EIN",
        model: "owner2SSNorEIN",
        required:true,
        min: 9,
        validator: validators.string.locale({
          fieldIsRequired: "This field is required!",
          textTooSmall: "Please input a valid SSN/EIN."
        }),
        cleaveOptions: {
          blocks: [9],
          numericOnly: true
        },
        styleClasses:'col-lg-4 custom-input input-top-placeholder'
     },
     {
        type: "input",
				inputType: "text",
        placeholder: "Full Address",
        model: "owner2FullAddress",
        required:true,
        validator:VueFormGenerator.validators.string,
        styleClasses:'col-lg-8 custom-input custom-lg-8 input-top-placeholder'
     },
     {
        type: 'select',
        placeholder: 'Owns residence?',
        model: 'owner2OwnResidence',
        required:true,
        validator: "required",
        values: ['Yes','No'],
        styleClasses:'col-lg-4 custom-input select-top-placeholder',
        selectOptions: {
          noneSelectedText: "Owns residence?"
        },
        onChanged: function(model, newVal, oldVal, field) {
          field.styleClasses = field.styleClasses + ' selected';
        }
     },
     {
       type: 'input',
       inputType: 'number',
       model: "owner2CreditScore",
       placeholder: 'Credit score',
       required:true,
       validator: VueFormGenerator.validators.integer,
       styleClasses:'col-lg-4 custom-input input-top-placeholder'
     },
     {
       type: 'cleave',
       inputType: 'number',
       model: "owner2Liquidity",
       placeholder: 'Liquidity',
       required:true,
       validator: VueFormGenerator.validators.string,
       cleaveOptions: {
         numeral: true,
         prefix: '$',
         numeralThousandsGroupStyle: 'thousand',
         delimiter: ',',
         noImmediatePrefix: true
       },
       styleClasses:'col-lg-4 custom-input input-top-placeholder'
     },   
     {
       type: 'cleave',
       inputType: 'number',
       model: "owner2NetWorth",
       placeholder: 'Net worth',
       required:true,
       validator: VueFormGenerator.validators.string,
       cleaveOptions: {
         numeral: true,
         prefix: '$',
         numeralThousandsGroupStyle: 'thousand',
         delimiter: ',',
         noImmediatePrefix: true
       },
       styleClasses:'col-lg-4 custom-input input-top-placeholder'
     }]
   },
   addOwnerSchema3: {
     fields:[
      {
        type: "input",
        inputType: "text",
        placeholder: "Person/Entity Full Name",
        model: "owner3Name",
        required:true,
        validator:VueFormGenerator.validators.string,
        styleClasses:'col-lg-4 custom-input input-top-placeholder'
     },
     {
        type: "input",
				inputType: "number",
        placeholder: "% of ownership",
        model: "owner3Ownership",
        required:true,
        validator: ['required', 'integer'],
        min: 1,
        max: 100,
        styleClasses:'col-lg-4 custom-input input-top-placeholder'
     },
     {
        type: 'cleave',
        inputType: 'text',
        model: "owner3DOBorFoundingDate",
        placeholder: 'Date of birth/Founding date [MM/DD/YYYY]',
        required:true,
        min: 10,
        validator: [validators.string.locale({
          fieldIsRequired: "This field is required!",
          textTooSmall: "Date format: MM/DD/YYYY."
        }), 'checkDateValid'],
        cleaveOptions: {
          blocks: [2, 2, 4],
          delimiters: ["/", "/"],
          numericOnly: true
        },
        styleClasses:'col-lg-4 custom-input input-top-placeholder'
     },
     {
        type: "cleave",
        inputType: "text",
        placeholder: "SSN/EIN",
        model: "owner3SSNorEIN",
        required:true,
        min: 9,
        validator: validators.string.locale({
          fieldIsRequired: "This field is required!",
          textTooSmall: "Please input a valid SSN/EIN."
        }),
        cleaveOptions: {
          blocks: [9],
          numericOnly: true
        },
        styleClasses:'col-lg-4 custom-input input-top-placeholder'
     },
     {
        type: "input",
				inputType: "text",
        placeholder: "Full Address",
        model: "owner3FullAddress",
        required:true,
        validator:VueFormGenerator.validators.string,
        styleClasses:'col-lg-8 custom-input custom-lg-8 input-top-placeholder'
     },
     {
        type: 'select',
        placeholder: 'Owns residence?',
        model: 'owner3OwnResidence',
        required:true,
        validator: "required",
        values: ['Yes','No'],
        styleClasses:'col-lg-4 custom-input select-top-placeholder',
        selectOptions: {
          noneSelectedText: "Owns residence?"
        },
        onChanged: function(model, newVal, oldVal, field) {
          field.styleClasses = field.styleClasses + ' selected';
        }
     },
     {
       type: 'input',
       inputType: 'number',
       model: "owner3CreditScore",
       placeholder: 'Credit score',
       required:true,
       validator: VueFormGenerator.validators.integer,
       styleClasses:'col-lg-4 custom-input input-top-placeholder'
     },
     {
       type: 'cleave',
       inputType: 'number',
       model: "owner3Liquidity",
       placeholder: 'Liquidity',
       required:true,
       validator: VueFormGenerator.validators.string,
       cleaveOptions: {
         numeral: true,
         prefix: '$',
         numeralThousandsGroupStyle: 'thousand',
         delimiter: ',',
         noImmediatePrefix: true
       },
       styleClasses:'col-lg-4 custom-input input-top-placeholder'
     },   
     {
       type: 'cleave',
       inputType: 'number',
       model: "owner3NetWorth",
       placeholder: 'Net worth',
       required:true,
       validator: VueFormGenerator.validators.string,
       cleaveOptions: {
         numeral: true,
         prefix: '$',
         numeralThousandsGroupStyle: 'thousand',
         delimiter: ',',
         noImmediatePrefix: true
       },
       styleClasses:'col-lg-4 custom-input input-top-placeholder'
     }]
   },
   addOwnerSchema4: {
     fields:[
      {
        type: "input",
        inputType: "text",
        placeholder: "Person/Entity Full Name",
        model: "owner4Name",
        required:true,
        validator:VueFormGenerator.validators.string,
        styleClasses:'col-lg-4 custom-input input-top-placeholder'
     },
     {
        type: "input",
				inputType: "number",
        placeholder: "% of ownership",
        model: "owner4Ownership",
        required:true,
        validator: ['required', 'integer'],
        min: 1,
        max: 100,
        styleClasses:'col-lg-4 custom-input input-top-placeholder'
     },
     {
        type: 'cleave',
        inputType: 'text',
        model: "owner4DOBorFoundingDate",
        placeholder: 'Date of birth/Founding date [MM/DD/YYYY]',
        required:true,
        min: 10,
        validator: [validators.string.locale({
          fieldIsRequired: "This field is required!",
          textTooSmall: "Date format: MM/DD/YYYY."
        }), 'checkDateValid'],
        cleaveOptions: {
          blocks: [2, 2, 4],
          delimiters: ["/", "/"],
          numericOnly: true
        },
        styleClasses:'col-lg-4 custom-input input-top-placeholder'
     },
     {
        type: "cleave",
        inputType: "text",
        placeholder: "SSN/EIN",
        model: "owner4SSNorEIN",
        required:true,
        min: 9,
        validator: validators.string.locale({
          fieldIsRequired: "This field is required!",
          textTooSmall: "Please input a valid SSN/EIN."
        }),
        cleaveOptions: {
          blocks: [9],
          numericOnly: true
        },
        styleClasses:'col-lg-4 custom-input input-top-placeholder'
     },
     {
        type: "input",
				inputType: "text",
        placeholder: "Full Address",
        model: "owner4FullAddress",
        required:true,
        validator:VueFormGenerator.validators.string,
        styleClasses:'col-lg-8 custom-input custom-lg-8 input-top-placeholder'
     },
     {
        type: 'select',
        placeholder: 'Owns residence?',
        model: 'owner4OwnResidence',
        required:true,
        validator: "required",
        values: ['Yes','No'],
        styleClasses:'col-lg-4 custom-input select-top-placeholder',
        selectOptions: {
          noneSelectedText: "Owns residence?"
        },
        onChanged: function(model, newVal, oldVal, field) {
          field.styleClasses = field.styleClasses + ' selected';
        }
     },
     {
       type: 'input',
       inputType: 'number',
       model: "owner4CreditScore",
       placeholder: 'Credit score',
       required:true,
       validator: VueFormGenerator.validators.integer,
       styleClasses:'col-lg-4 custom-input input-top-placeholder'
     },
     {
       type: 'cleave',
       inputType: 'number',
       model: "owner4Liquidity",
       placeholder: 'Liquidity',
       required:true,
       validator: VueFormGenerator.validators.string,
       cleaveOptions: {
         numeral: true,
         prefix: '$',
         numeralThousandsGroupStyle: 'thousand',
         delimiter: ',',
         noImmediatePrefix: true
       },
       styleClasses:'col-lg-4 custom-input input-top-placeholder'
     },   
     {
       type: 'cleave',
       inputType: 'number',
       model: "owner4NetWorth",
       placeholder: 'Net worth',
       required:true,
       validator: VueFormGenerator.validators.string,
       cleaveOptions: {
         numeral: true,
         prefix: '$',
         numeralThousandsGroupStyle: 'thousand',
         delimiter: ',',
         noImmediatePrefix: true
       },
       styleClasses:'col-lg-4 custom-input input-top-placeholder'
     }]
   },
   ownerSpecialSchema: {
    fields:[
     {
        type: 'select',
        placeholder: 'Had a property foreclosed in last 3 years?',
        model: 'anyPropertyForeclosed',
        required: true,
        validator: "required",
        values: ['Yes','No'],
        styleClasses:'col-lg-4 custom-input select-top-placeholder',
        selectOptions: {
          noneSelectedText: "Had a property foreclosed in last 3 years?"
        },
        onChanged: function(model, newVal, oldVal, field) {
          field.styleClasses = field.styleClasses + ' selected';
        }
     },
     {
        type: 'select',
        placeholder: 'Filed for bankruptcy in last 5 years?',
        model: 'anyFiledBankruptcy',
        required:true,
        validator: "required",
        values: ['Yes','No'],
        styleClasses:'col-lg-4 custom-input select-top-placeholder',
        selectOptions: {
          noneSelectedText: "Filed for bankruptcy in last 5 years?"
        },
        onChanged: function(model, newVal, oldVal, field) {
          field.styleClasses = field.styleClasses + ' selected';
        }
     },
     {
        type: 'select',
        placeholder: 'Missed mortgage payments in last 12 months?',
        model: 'anyMissedMortgage',
        required:true,
        validator: "required",
        values: ['Yes','No'],
        styleClasses:'col-lg-4 custom-input select-top-placeholder',
        selectOptions: {
          noneSelectedText: "Missed mortgage payments in last 12 months?"
        },
        onChanged: function(model, newVal, oldVal, field) {
          field.styleClasses = field.styleClasses + ' selected';
        }
     },
     {
        type: 'select',
        placeholder: 'Failed to file federal tax returns for last 3 years?',
        model: 'anyFailedFederalTaxReturn',
        required:true,
        validator: "required",
        values: ['Yes','No'],
        styleClasses:'col-lg-4 custom-input select-top-placeholder',
        selectOptions: {
          noneSelectedText: "Failed to file federal tax returns for last 3 years?"
        },
        onChanged: function(model, newVal, oldVal, field) {
          field.styleClasses = field.styleClasses + ' selected';
        }
     },
     {
        type: 'select',
        placeholder: 'Are an borrowers or guarantors a foreign national?',
        model: 'anyForeignNational',
        required:true,
        validator: "required",
        values: ['Yes','No'],
        styleClasses:'col-lg-4 custom-input select-top-placeholder',
        selectOptions: {
          noneSelectedText: "Are an borrowers or guarantors a foreign national?"
        },
        onChanged: function(model, newVal, oldVal, field) {
          field.styleClasses = field.styleClasses + ' selected';
        }
     },
     {
        type: 'select',
        placeholder: 'Are there back real estate taxes owed on subject property?',
        model: 'anyRealEstateTaxOwed',
        required:true,
        validator: "required",
        values: ['Yes','No'],
        styleClasses:'col-lg-4 custom-input select-top-placeholder',
        selectOptions: {
          noneSelectedText: "Are there back real estate taxes owed on subject property?"
        },
        onChanged: function(model, newVal, oldVal, field) {
          field.styleClasses = field.styleClasses + ' selected';
        }
     }
    ]
   },
   contactInfoSchema:{
     fields:[
      {
        type: "input",
        inputType: "text",
        placeholder: "First Name",
        model: "firstName",
        required:true,
        validator:VueFormGenerator.validators.string,
        styleClasses:'col-lg-4 custom-input input-top-placeholder'
      },
      {
          type: "input",
          inputType: "text",
          placeholder: "Last Name",
          model: "lastName",
          required:true,
          validator:VueFormGenerator.validators.string,
          styleClasses:'col-lg-4 custom-input input-top-placeholder'
      },
      {
        type: "input",
				inputType: "email",
        placeholder: "Email Address",
        model: "personalEmail",
        hint: "<br><br>",
        required:true,
        validator:VueFormGenerator.validators.email,
        disabled: function (model) {
          return model.customerType == '1';
        },
        styleClasses:'col-lg-4 custom-input input-top-placeholder'
      },
      {
        type: "cleave",
				inputType: "text",
        placeholder: "Mobile Phone",
        model: "personalPhone",
        hint: "By providing your mobile number, you agree to receive communication from American Credit by call or text. Standard data or messaging rates may apply.",
        required:true,
        min: 13,
        validator: validators.string.locale({
          fieldIsRequired: "This field is required!",
          textTooSmall: "Please input a valid number."
        }),
        cleaveOptions: {
          blocks: [0, 3, 3, 4],
          delimiters: ["(", ")", "-"],
          numericOnly: true
        },
        styleClasses:'col-lg-4 custom-input input-top-placeholder'
      }]
   },
   mailingAddressSchema:{
     fields: [
      {
        type: "input",
				inputType: "text",
        placeholder: "Address",
        model: "ownerAddress",
        required:true,
        validator:VueFormGenerator.validators.string,
        styleClasses:'col-lg-8 custom-input custom-lg-8 input-top-placeholder'
     },
     {
        type: "input",
				inputType: "text",
        placeholder: "Address Line 2",
        model: "ownerAddress2",
        styleClasses:'col-lg-8 custom-input custom-lg-8 input-top-placeholder'
     },
     {
        type: "input",
				inputType: "text",
        placeholder: "City",
        model: "ownerCity",
        required:true,
        validator:VueFormGenerator.validators.string,
        styleClasses:'col-lg-8 custom-input custom-lg-8 input-top-placeholder'
     },
     {
        type: 'select',
        placeholder: 'State',
        model: 'ownerState',
        required:true,
        validator: "required",
        values: ['Alabama','Alaska','Arizona','Arkansas','California','Colorado','Connecticut','Delaware','Florida','Georgia','Hawaii','Idaho','Illinois','Indiana','Iowa','Kansas','Kentucky','Louisiana','Maine','Maryland','Massachusetts','Michigan','Minnesota','Mississippi','Missouri','Montana','Nebraska','Nevada','New Hampshire','New Jersey','New Mexico','New York','North Carolina','North Dakota','Ohio','Oklahoma','Oregon','Pennsylvania','Rhode Island','South Carolina','South Dakota','Tennessee','Texas','Utah','Vermont','Virginia','Washington','West Virginia','Wisconsin','Wyoming'],
        styleClasses:'col-lg-4 custom-input select-top-placeholder',
        selectOptions: {
          noneSelectedText: "State"
        },
        onChanged: function(model, newVal, oldVal, field) {
          field.styleClasses = field.styleClasses + ' selected';
        }
     },
     {
        type: "cleave",
				inputType: "text",
        model: "ownerZip",
        placeholder: "Zip",
        required:true,
        min: 5,
        validator: validators.string.locale({
          fieldIsRequired: "This field is required!",
          textTooSmall: "Please input a valid zip."
        }),
        cleaveOptions: {
          blocks: [5],
          numericOnly: true
        },
        styleClasses:'col-lg-4 custom-input input-top-placeholder'
     }
     ]
   }
  }
 },
 computed: {
    ...mapGetters({
      userInfo: types.GET_USER
    }),
    currentDate: function() {
      return moment(new Date()).format('MM/DD/YY');
    }
  },
  methods: {
    ...mapActions({
      setSuccessMessage: types.SET_SUCCESS_MESSAGE,
      setAlertMessage: types.SET_FAIL_MESSAGE,
      getPersonalInitData: types.GET_PERSONAL_INIT_DATA
    }),
    onComplete: function(){
      // alert('Yay. Done!');
      // return console.log(this.uploadedFiles);
      this.apply();
    },
    checkFileTypes(files) {
      var allTypesSelected = true;
      files.forEach(file => {
        if(!file.category || file.category == '') {
          allTypesSelected = false;
        }
      })
      return allTypesSelected;
    },

    firstPageContinue() {
      var _this = this;
      _this.clientCustomerId = _this.userInfo.crmCustomerId;
      var applyData = {
        tokenId: _this.userInfo.token,
        clientCustomerId: _this.userInfo.crmCustomerId,
        frontApplyProductId: 10000059231105,
        frontApplyMoney: this.parseCurrency(_this.model.loanAmount),
        frontInformationSources: '5',
        frontApplyExpiresUnit: 2,
        frontApplyExpires: _this.model.amortizationInMonths
      };

      api.mgxyBrokerApply(applyData)
      .then(res => {
        console.log(res);
        var _data = res.data;
        if (_data.code == 0) {
          _this.frontApplyId = _data.result.frontApplyId;
          api.postForm("/mobile/item/loanItemFrontApply/mgxyUpdateApplyForFinish.ht",
            {
              tokenId: _this.userInfo.token,
              frontApplyId: _this.frontApplyId
            }
          ).then(res => {
            // _this.isLoading = false;
            api.postForm("/mobile/item/loanItemFrontApply/updateSBL01.ht", {
              tokenId: _this.userInfo.token,
              customerId: _this.clientCustomerId,
              frontApplyId: _this.frontApplyId,
              
              name: _this.model.fullName,
              street: _this.model.fullAddress,
              businessDesc: '',
            }).then(res => {
              var _data = res.data;
              if (_data.code == 0) {
                console.log(res);
                console.log("Success to save dummy business information");
                _this.savePropertyAndLoan();
              } else {
                this.setAlertMessage({
                  show: true,
                  content: _data.msg
                });
              }
            });
            _this.submittedAlready = true;
          });
        } else {
          this.setAlertMessage({
            show: true,
            content: _data.msg
          });
        }
      });
    },

    apply() {
      if(this.uploadedFiles && this.uploadedFiles.length > 0) {
        if(!this.checkFileTypes(this.uploadedFiles)) {
          this.setAlertMessage({
            show: true,
            content: "Please select types for all uploaded documents first!"
          });
        }
      }

      //add loading animation after click submit
      var submitLoadingInstance = Loading.service({ fullscreen: true, lock: true });
      setTimeout(() => {
        submitLoadingInstance.close();
      }, 3000)

      var _this = this;
      if(_this.model.customerType == '1') {

        api.postForm("/mobile/item/loanItemFrontApply/updateUpload.ht", {
          tokenId: _this.userInfo.token,
          customerId: _this.clientCustomerId,
          frontApplyId: _this.frontApplyId,
          reComments: _this.brokerNote
        }).then(res => {
          console.log(res);
          console.log("Success to save comment");

          //save contats to hubspot
          this.createOrUpdateHubspotContact(true);

          //save files into database
          var filesToSave = {
            files: _this.uploadedFiles,
            application_id: _this.frontApplyId
          }
          axios.post("https://api.amcredit.com/apply/update", filesToSave);

          //send welcome email to new applicant
          axios.post("https://api.amcredit.com/apply/sendTransactionalEmail", {customerEmail: this.model.personalEmail, firstName: this.model.firstName, emailTemplate: 'amcredit-application-completed-welcome', emailSubject: 'Thank you for choosing American Credit for your Commercial Real Estate financing' })
          .then(res => console.log(res))
          .catch(err => console.log(err.message));

          var sendData = {
            email: this.model.personalEmail, 
            firstName: this.model.firstName, 
            lastName: this.model.lastName, 
            phone: this.model.personalPhone, 
            name: this.model.fullName,
            message: 'Customer submitted new real estate loan application!'
          }
          // new application slack notification
          axios.create({ transformRequest: [(data, _headers) => JSON.stringify(data)] })
                  .post('https://hooks.zapier.com/hooks/catch/11204908/bpsg1lq/', sendData);

          this.setSuccessMessage({
            show: true,
            content: "Submission successful!"
          });
          setTimeout(() => {
            this.$router.push('/apply/thank-you');
            window.location.reload(true);
          }, 3000)
        });

      } else {
        this.submitLoanApplication();
      }  
    },

    submitLoanApplication() {
      var _this = this;
      var registerData = {
          firstName: _this.model.firstName,
          lastName: _this.model.lastName,
          middleName: '',
          email: _this.model.personalEmail,
          brokerId: _this.userInfo.crmCustomerId
      }

      api.brokerRegisterUser(registerData)
      .then(res => {
        if (Number(res.data.code) == 0) {
          var data = res.data.data;
          _this.clientCustomerId = data.crmCustomerId;
          
          api.mgxyBrokerApply({
              tokenId: _this.userInfo.token,
              clientCustomerId: _this.clientCustomerId,
              frontApplyProductId: 10000059231105,
              frontApplyMoney: this.parseCurrency(_this.model.loanAmount),
              frontInformationSources: '5',
              frontApplyExpiresUnit: 2,
              frontApplyExpires: _this.model.amortizationInMonths
            })
            .then(res => {
              console.log(res);
              var _data = res.data;
              if (_data.code == 0) {
                _this.frontApplyId = _data.result.frontApplyId;

                //save contats to hubspot
                this.createOrUpdateHubspotContact(true);

                //save files into database
                var filesToSave = {
                  files: _this.uploadedFiles,
                  application_id: _this.frontApplyId
                }
                axios.post("https://api.amcredit.com/apply/update", filesToSave);

                api.postForm("/mobile/item/loanItemFrontApply/mgxyUpdateApplyForFinish.ht",
                  {
                    tokenId: _this.userInfo.token,
                    frontApplyId: _this.frontApplyId
                  }
                ).then(res => {
                  // _this.isLoading = false;
                  _this.saveBusinessOwner(false);
                });
              } else {
                //save contats to hubspot
                this.createOrUpdateHubspotContact(false);
                this.setAlertMessage({
                  show: true,
                  content: _data.msg
                });
              }
            });
          return true;
        } else {
          if (res.data.result === "Registration failed, email has been registered") {
            this.setAlertMessage({
              show: true,
              content: 'Failed to submit application, business owner email already exist'
            });
            // alert("Failed to submit application, business owner email already exist");
          }
          return false;
        }
      });
    },

    saveBusinessOwner(secondPageContinue) {
      var _this = this;
      var postData = {
        customerId: _this.clientCustomerId,
        tokenId: _this.userInfo.token,

        firstName: _this.model.firstName,
        lastName: _this.model.lastName,
        phone: _this.model.personalPhone,
        streetAddress: _this.model.ownerAddress,
        streetAddressLine2: _this.model.ownerAddress2,
        cityName: _this.model.ownerCity,
        state: _this.model.ownerState || '',
        ssn: _this.model.ssn,
        zipCode: _this.model.ownerZip,
        title: _this.model.title || "",

        firstName2: _this.model.owner2FirstName,
        lastName2: _this.model.owner2LastName,
        ssn2: _this.model.owner2Ssn,
        email2: _this.model.owner2PersonalEmail,
        phone2: _this.model.owner2PersonalPhone,
        streetAddress2: _this.model.owner2Address,
        streetAddress2Line2: _this.model.owner2Address2,
        cityName2: _this.model.owner2City,
        state2: _this.model.owner2State || "",
        zipCode2: _this.model.owner2Zip,

        isValid: 1,
        customer_area: "",
        military: false,

        businessOwnership: '',
        businessOwnership2: _this.model.owner2Ownership
      }

      // if(_this.$route.query.email) {
      //   postData.firstName = _this.model.firstName;
      //   postData.lastName = _this.model.lastName;
      // }

      // if(_this.toggle) {
      //   postData.streetAddress = _this.model.address;
      //   postData.streetAddressLine2 = _this.model.address2;
      //   postData.cityName = _this.model.city;
      //   postData.state = _this.model.state;
      //   postData.zipCode = _this.model.zip;
      // }

      if(_this.showOwner2 && _this.owner2Toggle) {
        postData.streetAddress2 = _this.model.address;
        postData.streetAddress2Line2 = _this.model.address2;
        postData.cityName2 = _this.model.city;
        postData.state2 = _this.model.state;
        postData.zipCode2 = _this.model.zip;
      }

      api
        .postForm(
          "/mobile/item/loanItemFrontApply/mgxyBrokerUpdateApplyForPersonDetails.ht",
          postData 
        )
        .then(res => {
          console.log(res);
          var _data = res.data;
          this.isLoading = false;
          if (_data.code == 0) {
            // this.setAlertMessage({
            //   show: true,
            //   content: "Success to save personal information"
            // });
            console.log("Success to save personal information");
            _this.submitBusinessInfo(secondPageContinue);
          } else {
            this.setAlertMessage({
              show: true,
              content: _data.msg
            });
          }
        });
    },

    submitBusinessInfo(secondPageContinue) {
      var _this = this;
      api.postForm("/mobile/item/loanItemFrontApply/updateSBL01.ht", {
        tokenId: _this.userInfo.token,
        customerId: _this.clientCustomerId,
        frontApplyId: _this.frontApplyId,
        
        name: _this.model.fullName,
        street: _this.model.fullAddress,
        // street2: _this.model.address2,
        // city: _this.model.city,
        // state: _this.model.state,
        // zipCode: _this.model.zip,
        phone: _this.model.companyPhone,
        tin: _this.model.FederalID,
        structure: _this.model.taxClassification || '',
        industry: _this.model.businessDescription || '',
        yearsInBusiness: _this.model.yearsInBusiness,
        businessDesc: '',
        companyEmail: _this.model.companyEmail,
        stateOfIncorporation: _this.model.stateOfIncorporation || ''
      }).then(res => {
        //             alert(res.date.code);
        //             alert(res.date.msg);
        var _data = res.data;
        if (_data.code == 0) {
          console.log(res);
          // this.setAlertMessage({
          //   show: true,
          //   content: "Success to save business information"
          // });
          console.log("Success to save business information");
          if(secondPageContinue) {
            _this.saveOwnerInfo();
          } else {
            _this.submitVendorForm();
          }
        } else {
          this.setAlertMessage({
            show: true,
            content: _data.msg
          });
        }
      });
    },

    savePropertyAndLoan() {
      var propertyAndLoanData = {
        tokenId: this.userInfo.token,
        customerId: this.clientCustomerId,
        frontApplyId: this.frontApplyId,

        rePropertyAddress: this.model.address || '',
        rePropertyAddressLine2: this.model.address2 || '',
        rePropertyCity: this.model.city || '',
        rePropertyState: this.model.state || '',
        rePropertyZip: this.model.zip || '',
        reBuildingSqft: this.parseCurrency(this.model.buildingSqft) || '',
        reNumberOfUnits: this.model.numberOfUnits || '',
        rePercentOccupied: this.model.percentOccupied || '',
        reIfOwnerOccupyAny: this.model.ownerOccupied || false,
        reOwnerOccupySqft: this.parseCurrency(this.model.ownerOccupiedSqft) || '',
        rePropertyType: this.model.propertyType || '',
        rePropertyHave: this.model.propertyHave.join(', ') || '',
        rePropertyStyle: this.model.propertyStyle || '',

        reDesiredRate: this.model.desiredRate || '',
        reAmortizationInMonths: this.model.amortizationInMonths || '',
        reYspRebate: this.model.YSPRebate || '',
        reCurrentEstimatedValue: this.parseCurrency(this.model.currentEstimatedValue) || '',
        reMonthlyPmt: this.parseCurrency(this.model.monthlyPmt) || '',
        reAnnualPmt: this.parseCurrency(this.model.annualPmt) || '',
        reAnnualGrossIncome: this.parseCurrency(this.model.annualGrossIncome) || '',
        reAnnualOperatingExpense: this.parseCurrency(this.model.annualOperatingExpense) || '',
        reNetOperatingIncome: this.parseCurrency(this.model.netoperatingIncome) || '',
        reLtv: this.model.LTV || '',
        reDscr: this.model.DSCR || '',
        reCapRate: this.model.CAPRate || '',
        reFinanceType: this.model.financeType || '',
        re1031Exchange: this.model.is1031 || false,
        reCurrentSalesPrice: this.parseCurrency(this.model.currentSalesPrice) || '',
        reTargetClosingDate: this.model.targetClosingDate || '',
        reCurrentLoanBalance: this.parseCurrency(this.model.currentLoanBalance) || '',
        reCurrentRate: this.model.currentRate || '',
        reLoanMaturityDate: this.model.loanMaturityDate || '',
        reCurrentLender: this.model.currentLender || '',
        reAcquisitionPrice: this.parseCurrency(this.model.acquisitionPrice) || '',
        reMoYrAcquired: this.model.MoYrAcquired || '',
        reEstimatedCashoutAvailable: this.parseCurrency(this.model.estimatedCashout) || '',
        reCashout1Usage: this.model.cashoutUsage1 || '',
        reCashout2Usage: this.model.cashoutUsage2 || '',
        reCashout3Usage: this.model.cashoutUsage3 || '',
        reCashout1Amount: this.parseCurrency(this.model.cashoutAmount1) || '',
        reCashout2Amount: this.parseCurrency(this.model.cashoutAmount2) || '',
        reCashout3Amount: this.parseCurrency(this.model.cashoutAmount3) || ''
      }

      api.postForm("/mobile/item/loanItemFrontApply/updateUpload.ht", propertyAndLoanData)
        .then(res => {
          console.log(res);
          console.log("Success to save page 1 information");
        });
    },

    saveOwnerInfo() {
      var ownerInfoData = {
        tokenId: this.userInfo.token,
        customerId: this.clientCustomerId,
        frontApplyId: this.frontApplyId,

        reOwner1Name: this.model.fullName,
        reOwner1Ownership: this.model.ownership || '',
        reOwner1Liquidity: this.parseCurrency(this.model.liquidity) || '',
        reOwner1DOBorFoundingDate: this.model.DOBorFoundingDate || '',
        reOwner1SSNorEIN: this.model.SSNorEIN || '',
        reOwner1FullAddress: this.model.fullAddress,
        reOwner1OwnsResidence: this.model.ownResidence || '',
        reOwner1CreditScore: this.model.creditScore || '',
        reOwner1NetWorth: this.parseCurrency(this.model.netWorth) || '',
        reOwner2Name: this.model.owner2Name,
        reOwner2Ownership: this.model.owner2Ownership || '',
        reOwner2Liquidity: this.parseCurrency(this.model.owner2Liquidity) || '',
        reOwner2DOBorFoundingDate: this.model.owner2DOBorFoundingDate || '',
        reOwner2SSNorEIN: this.model.owner2SSNorEIN || '',
        reOwner2FullAddress: this.model.owner2FullAddress,
        reOwner2OwnsResidence: this.model.owner2OwnResidence || '',
        reOwner2CreditScore: this.model.owner2CreditScore || '',
        reOwner2NetWorth: this.parseCurrency(this.model.owner2NetWorth) || '',
        reOwner3Name: this.model.owner3Name,
        reOwner3Ownership: this.model.owner3Ownership || '',
        reOwner3Liquidity: this.parseCurrency(this.model.owner3Liquidity) || '',
        reOwner3DOBorFoundingDate: this.model.owner3DOBorFoundingDate || '',
        reOwner3SSNorEIN: this.model.owner3SSNorEIN || '',
        reOwner3FullAddress: this.model.owner3FullAddress,
        reOwner3OwnsResidence: this.model.owner3OwnResidence || '',
        reOwner3CreditScore: this.model.owner3CreditScore || '',
        reOwner3NetWorth: this.parseCurrency(this.model.owner3NetWorth) || '',
        reOwner4Name: this.model.owner4Name,
        reOwner4Ownership: this.model.owner4Ownership || '',
        reOwner4Liquidity: this.parseCurrency(this.model.owner4Liquidity) || '',
        reOwner4DOBorFoundingDate: this.model.owner4DOBorFoundingDate || '',
        reOwner4SSNorEIN: this.model.owner4SSNorEIN || '',
        reOwner4FullAddress: this.model.owner4FullAddress,
        reOwner4OwnsResidence: this.model.owner4OwnResidence || '',
        reOwner4CreditScore: this.model.owner4CreditScore || '',
        reOwner4NetWorth: this.parseCurrency(this.model.owner4NetWorth) || '',
        reOwnersAnyPropertyForeclosed: this.model.anyPropertyForeclosed,
        reOwnersAnyFiledBankruptcy: this.model.anyFiledBankruptcy,
        reOwnersAnyMissedMortgage: this.model.anyMissedMortgage,
        reOwnersAnyFailedFederalTaxReturn: this.model.anyFailedFederalTaxReturn,
        reOwnersAnyForeignNational: this.model.anyForeignNational,
        reOwnersAnyRealEstateTaxOwed: this.model.anyRealEstateTaxOwed
      }

      api.postForm("/mobile/item/loanItemFrontApply/updateUpload.ht", ownerInfoData)
        .then(res => {
          console.log(res);
          console.log("Success to save page 2 information");
        });
    },
	
    submitVendorForm() {
      var vendorData = {
        tokenId: this.userInfo.token,
        customerId: this.clientCustomerId,
        frontApplyId: this.frontApplyId,

        rePropertyAddress: this.model.address || '',
        rePropertyAddressLine2: this.model.address2 || '',
        rePropertyCity: this.model.city || '',
        rePropertyState: this.model.state || '',
        rePropertyZip: this.model.zip || '',
        reBuildingSqft: this.parseCurrency(this.model.buildingSqft) || '',
        reNumberOfUnits: this.model.numberOfUnits || '',
        rePercentOccupied: this.model.percentOccupied || '',
        reIfOwnerOccupyAny: this.model.ownerOccupied || false,
        reOwnerOccupySqft: this.parseCurrency(this.model.ownerOccupiedSqft) || '',
        rePropertyType: this.model.propertyType || '',
        rePropertyHave: this.model.propertyHave.join(', ') || '',
        rePropertyStyle: this.model.propertyStyle || '',
        reOwner1Name: this.model.fullName,
        reOwner1Ownership: this.model.ownership || '',
        reOwner1Liquidity: this.parseCurrency(this.model.liquidity) || '',
        reOwner1DOBorFoundingDate: this.model.DOBorFoundingDate || '',
        reOwner1SSNorEIN: this.model.SSNorEIN || '',
        reOwner1FullAddress: this.model.fullAddress,
        reOwner1OwnsResidence: this.model.ownResidence || '',
        reOwner1CreditScore: this.model.creditScore || '',
        reOwner1NetWorth: this.parseCurrency(this.model.netWorth) || '',
        reOwner2Name: this.model.owner2Name,
        reOwner2Ownership: this.model.owner2Ownership || '',
        reOwner2Liquidity: this.parseCurrency(this.model.owner2Liquidity) || '',
        reOwner2DOBorFoundingDate: this.model.owner2DOBorFoundingDate || '',
        reOwner2SSNorEIN: this.model.owner2SSNorEIN || '',
        reOwner2FullAddress: this.model.owner2FullAddress,
        reOwner2OwnsResidence: this.model.owner2OwnResidence || '',
        reOwner2CreditScore: this.model.owner2CreditScore || '',
        reOwner2NetWorth: this.parseCurrency(this.model.owner2NetWorth) || '',
        reOwner3Name: this.model.owner3Name,
        reOwner3Ownership: this.model.owner3Ownership || '',
        reOwner3Liquidity: this.parseCurrency(this.model.owner3Liquidity) || '',
        reOwner3DOBorFoundingDate: this.model.owner3DOBorFoundingDate || '',
        reOwner3SSNorEIN: this.model.owner3SSNorEIN || '',
        reOwner3FullAddress: this.model.owner3FullAddress,
        reOwner3OwnsResidence: this.model.owner3OwnResidence || '',
        reOwner3CreditScore: this.model.owner3CreditScore || '',
        reOwner3NetWorth: this.parseCurrency(this.model.owner3NetWorth) || '',
        reOwner4Name: this.model.owner4Name,
        reOwner4Ownership: this.model.owner4Ownership || '',
        reOwner4Liquidity: this.parseCurrency(this.model.owner4Liquidity) || '',
        reOwner4DOBorFoundingDate: this.model.owner4DOBorFoundingDate || '',
        reOwner4SSNorEIN: this.model.owner4SSNorEIN || '',
        reOwner4FullAddress: this.model.owner4FullAddress,
        reOwner4OwnsResidence: this.model.owner4OwnResidence || '',
        reOwner4CreditScore: this.model.owner4CreditScore || '',
        reOwner4NetWorth: this.parseCurrency(this.model.owner4NetWorth) || '',
        reOwnersAnyPropertyForeclosed: this.model.anyPropertyForeclosed,
        reOwnersAnyFiledBankruptcy: this.model.anyFiledBankruptcy,
        reOwnersAnyMissedMortgage: this.model.anyMissedMortgage,
        reOwnersAnyFailedFederalTaxReturn: this.model.anyFailedFederalTaxReturn,
        reOwnersAnyForeignNational: this.model.anyForeignNational,
        reOwnersAnyRealEstateTaxOwed: this.model.anyRealEstateTaxOwed,
        reComments: this.brokerNote,
        reDesiredRate: this.model.desiredRate || '',
        reAmortizationInMonths: this.model.amortizationInMonths || '',
        reYspRebate: this.model.YSPRebate || '',
        reCurrentEstimatedValue: this.parseCurrency(this.model.currentEstimatedValue) || '',
        reMonthlyPmt: this.parseCurrency(this.model.monthlyPmt) || '',
        reAnnualPmt: this.parseCurrency(this.model.annualPmt) || '',
        reAnnualGrossIncome: this.parseCurrency(this.model.annualGrossIncome) || '',
        reAnnualOperatingExpense: this.parseCurrency(this.model.annualOperatingExpense) || '',
        reNetOperatingIncome: this.parseCurrency(this.model.netoperatingIncome) || '',
        reLtv: this.model.LTV || '',
        reDscr: this.model.DSCR || '',
        reCapRate: this.model.CAPRate || '',
        reFinanceType: this.model.financeType || '',
        re1031Exchange: this.model.is1031 || false,
        reCurrentSalesPrice: this.parseCurrency(this.model.currentSalesPrice) || '',
        reTargetClosingDate: this.model.targetClosingDate || '',
        reCurrentLoanBalance: this.parseCurrency(this.model.currentLoanBalance) || '',
        reCurrentRate: this.model.currentRate || '',
        reLoanMaturityDate: this.model.loanMaturityDate || '',
        reCurrentLender: this.model.currentLender || '',
        reAcquisitionPrice: this.parseCurrency(this.model.acquisitionPrice) || '',
        reMoYrAcquired: this.model.MoYrAcquired || '',
        reEstimatedCashoutAvailable: this.parseCurrency(this.model.estimatedCashout) || '',
        reCashout1Usage: this.model.cashoutUsage1 || '',
        reCashout2Usage: this.model.cashoutUsage2 || '',
        reCashout3Usage: this.model.cashoutUsage3 || '',
        reCashout1Amount: this.parseCurrency(this.model.cashoutAmount1) || '',
        reCashout2Amount: this.parseCurrency(this.model.cashoutAmount2) || '',
        reCashout3Amount: this.parseCurrency(this.model.cashoutAmount3) || ''
      }

      api.postForm("/mobile/item/loanItemFrontApply/updateUpload.ht", vendorData)
        .then(res => {
          console.log(res);
          console.log("Success to save vendor information");

          //send welcome email to new applicant
          axios.post("https://api.amcredit.com/apply/sendTransactionalEmail", {customerEmail: this.model.personalEmail, firstName: this.model.firstName, emailTemplate: 'amcredit-application-completed-welcome', emailSubject: 'Thank you for choosing American Credit for your equipment financing' })
          .then(res => console.log(res))
          .catch(err => console.log(err.message));

          var sendData = {
            email: this.model.personalEmail, 
            firstName: this.model.firstName, 
            lastName: this.model.lastName, 
            phone: this.model.personalPhone, 
            name: this.model.fullName, 
            message: 'Customer submitted new real estate loan application!'
          }

          if(this.model.customerType == '8') {
            sendData.message = 'Broker (' + this.userInfo.crmCustomerLoginName + ') submitted new real estate loan application!'
          }

          // new application slack notification
          axios.create({ transformRequest: [(data, _headers) => JSON.stringify(data)] })
                  .post('https://hooks.zapier.com/hooks/catch/11204908/bpsg1lq/', sendData);

          var referralData = {
            partnerId: this.model.partnerId,
            orderNumber: this.frontApplyId,
            firstName: this.model.firstName,
            lastName: this.model.lastName,
            email: this.model.personalEmail,
            customerId: this.clientCustomerId,
            commission: '500',
            loanAmount: this.model.loanAmount.replace(/[^\d|\.]/g, "")
          }

          // new application slack notification
          axios.create({ transformRequest: [(data, _headers) => JSON.stringify(data)] })
                  .post('https://hooks.zapier.com/hooks/catch/11204908/2ry7kbf/', referralData);

          this.setSuccessMessage({
            show: true,
            content: "Submission successful!"
          });
          setTimeout(() => {
            this.$router.push('/brokerCenter');
            window.location.reload(true);
          }, 3000)
        });
    },

    createOrUpdateHubspotContact (applied) {
      var _this = this;
      // hubspot create new contact
      // POST request using axios with set headers

      var dataProperties = [
        { property: 'applied_successfully', value: applied },
        { property: 'website_new_apply_tag', value: 'Website new estate loan application' },
        { property: 'applied_product', value: 'Real Estate Loan' },
        { property: 'company', value: _this.model.fullName },
        { property: 'business_phone', value: _this.model.companyPhone },
        { property: 'business_address', value: _this.model.address },
        { property: 'business_city', value: _this.model.city },
        { property: 'business_state_transmit', value: _this.model.state },
        { property: 'business_zip_code', value: _this.model.zip },
        { property: 'firstname', value: _this.model.firstName },
        { property: 'lastname', value: _this.model.lastName },
        { property: 'address', value: _this.model.ownerAddress },
        { property: 'city', value: _this.model.ownerCity },
        { property: 'zip', value: _this.model.ownerZip },
        { property: 'phone', value: _this.model.personalPhone },
        { property: 'ownership_percentage', value: _this.model.ownership },
        { property: 'first_name_person_2', value: _this.model.owner2FirstName },
        { property: 'last_name_person_2', value: _this.model.owner2LastName },
        { property: 'street_address_person_2', value: _this.model.owner2Address },
        { property: 'city_person_2', value: _this.model.owner2City },
        { property: 'state_person_2_transmit', value: _this.model.owner2State },
        { property: 'postal_code_person_2', value: _this.model.owner2Zip },
        { property: 'phone_person_2', value: _this.model.owner2PersonalPhone },
        { property: 'ownership_person_2', value: _this.model.owner2PersonalEmail },
        { property: 'contact_type', value: _this.model.customerType == '1' ? 'Direct' : 'Broker' }
      ];

      if(_this.model.ownerState != null) {
        dataProperties.push({ property: 'applicant_state', value: _this.model.ownerState });
      }

      if(_this.model.equipmentCost != '') {
        dataProperties.push({ property: 'deal_amount', value: _this.model.equipmentCost });
      }

      // if(_this.model.term != '') {
      //   dataProperties.push({ property: 'deal_loan_term', value: _this.model.term });
      // }

      console.log(dataProperties)

      const body = {
        email: _this.model.personalEmail,
        data: {
          properties: dataProperties
        }
      }
      const headers = {
        'Content-Type': 'application/json'
      }

      axios({
        url: '/hsapi/create_or_update_contact',
        method: 'post',
        baseURL: 'https://api.amcredit.com/hubspot',
        data: body,
        headers: headers
      })
        .then(response => console.log(response))
        .catch(error => console.log(error.message))
    },


    scrollToTop: function() {
      window.scrollTo(0,0);
    },

    parseCurrency(value) {
      value = value.toString();
      // removing everything except \d and \. (numbers and decimal)
      let parsed = value.replace(/[^\d|\.]/g, "");
      return Number(parsed);
    },

    validateFirstTab: function(){
      let valid_real_estate_loan = this.$refs.firstTabForm.validate();
      if(this.model.propertyHave.length == 0) {
        return this.setAlertMessage({
          show: true,
          content: 'Please select all options apply to the property.'
        });
      }
      if(valid_real_estate_loan) {
        //add loading animation after click submit
        // var firstPageLoadingInstance = Loading.service({ fullscreen: true, lock: true });
        // setTimeout(() => {
        //   firstPageLoadingInstance.close();
        // }, 2000)

        if(this.submittedAlready) {
          this.savePropertyAndLoan();
        } else {
          this.firstPageContinue();
        }

        return true;
      } else {
        return false;
      }
    },
    validateSecondTab: function(){
      var _this = this;
      let valid_owner = this.$refs.secondTabForm.validate(),
          valid_owner_special = this.$refs.ownerSpecialForm.validate(),
          valid_contact_info = this.$refs.contactInfoForm.validate(),
          valid_owner2 = true,
          valid_owner3 = true,
          valid_owner4 = true;

      if(_this.numOfOwner == 2) {
        valid_owner2 = this.$refs.addOwner2Form.validate();
      }

      if(_this.numOfOwner == 3) {
        valid_owner3 = this.$refs.addOwner3Form.validate();
      }

      if(_this.numOfOwner == 4) {
        valid_owner4 = this.$refs.addOwner4Form.validate();
      }

      if(valid_owner && valid_owner_special && valid_contact_info && valid_owner2 && valid_owner3 && valid_owner4) {
        //add loading animation after click submit
        // var secondPageLoadingInstance = Loading.service({ fullscreen: true, lock: true });
        // setTimeout(() => {
        //   secondPageLoadingInstance.close();
        // }, 2000)
        this.saveBusinessOwner(true);
        return true;
      } else {
        return false;
      }
    },

    validateConsentTab: function(){
      if(this.consentToggle) {
        this.signAgreement();
        return true;
      } else {
        this.setAlertMessage({
          show: true,
          content: 'You need to review and agree with the consent clauses to proceed.'
        });
        return false;
      }
      
    },

    signAgreement() {
      const _this = this;
      var fullName = _this.model.firstName + ' ' + _this.model.lastName;
      api
        .postForm(
          "/mobile/item/loanItemFrontApply/mgxyConfirmSignDeclaration.ht",
          {
            tokenId: _this.userInfo.token,
            contractId: 10000058500118,
            fullName: fullName
          }
        )
        .then(res => {
          const data = res.data;
          console.log(data.msg);
        });
    },

    addOwner: function(){
      var newAddOwner = {toggle: true}
      this.addOwners.push(newAddOwner);
    },

    deleteOwner: function(index){
      this.addOwners.splice(index, 1);
    },

    addOwner2: function(){
      this.numOfOwner += 1;
    },

    deleteOwner2: function(index){
      this.showOwner2 = false;
      this.numOfOwner -= 1;
    },

    editBusiness: function() {
      this.$refs.wizard.changeTab(3, 0);
    },

    editOwner: function() {
      this.$refs.wizard.changeTab(3, 1);
    }
  },    
  mounted() {
    if(this.$route.query.ghref) {
      this.model.partnerId = this.$route.query.ghref.split(':')[1];
    }
    if(this.$route.query.amount) {
      this.model.equipmentCost = Number(this.$route.query.amount);
    }
    if(this.$route.query.term) {
      this.model.loanTerm = this.$route.query.term * 12;
    }
    if(this.$route.query.equipment) {
      this.model.equipmentDescription = this.$route.query.equipment;
    }
    if(this.$route.query.yearsInBusiness) {
      this.model.yearsInBusiness = this.$route.query.yearsInBusiness;
    }
    console.log(this.userInfo);
    // this.model.promoCode = this.userInfo.promoCode;
    // if(this.model.promoCode && this.userInfo.promoCode.toLowerCase() == 'amcredit') {
    //   this.model.displayPromoCode = true;
    // }
    this.model.customerType = this.userInfo.crmCustomerType;
    if(this.model.customerType == '1') {
      this.model.personalEmail = this.userInfo.crmCustomerLoginName;
    }
    VueFormGenerator.validators.checkTotalOwnership = function(value, field, model) {
      if(model.ownership > 0 && model.ownership + value > 100) {
        return ["Total business ownership cannot exceed 100%"];
      }
    }
    // Validates that the input string is a valid date formatted as "mm/dd/yyyy"
    VueFormGenerator.validators.checkDateValid = function (value)
    {
      // First check for the pattern
      if(!/^\d{1,2}\/\d{1,2}\/\d{4}$/.test(value))
        return ["Please input a valid date."];

      // Parse the date parts to integers
      var parts = value.split("/");
      var day = parseInt(parts[1], 10);
      var month = parseInt(parts[0], 10);
      var year = parseInt(parts[2], 10);

      // Check the ranges of month and year
      if(year < 1800 || month == 0 || month > 12)
        return ["Please input a valid date."];

      var monthLength = [ 31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31 ];

      // Adjust for leap years
      if(year % 400 == 0 || (year % 100 != 0 && year % 4 == 0))
        monthLength[1] = 29;

      // Check the range of the day
      if(day <= 0 || day > monthLength[month - 1]) {
        return ["Please input a valid date."];
      }
    };
    // this.getPersonalInitData({
    //   token: this.userInfo.token,
    //   customerId: this.userInfo.crmCustomerId
    // }).then(res => {
    //   console.log(res);
    //   if (Number(res.data.code) === 0) {
    //     const data = res.data.result;
    //     console.log(data);
    //   }
    // });
  }
}
</script>

<style lang="scss" scoped>
  .reveal-overlay {
    font-family: Montserrat,sans-serif,"Helvetica Neue",sans-serif;
    font-weight: 400;
    line-height: 1.5;
    color: #053A7A;
    -webkit-font-smoothing: antialiased;
    margin: 0;
    padding: 0;
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 1005;
    background-color: rgba(0,0,0,.45);
    overflow-y: auto;
    display: block;
    #contact-modal {
      font-family: Montserrat,sans-serif,"Helvetica Neue",sans-serif;
      font-weight: 400;
      line-height: 1.5;
      color: #053A7A;
      -webkit-font-smoothing: antialiased;
      z-index: 1006;
      backface-visibility: hidden;
      padding: 2.5rem 2rem 1.5rem;
      border: 1px solid #787d78;
      border-radius: .25rem;
      background-color: #fff;
      position: relative;
      overflow-y: auto;
      min-height: 0;
      right: auto;
      left: auto;
      margin: 0 auto;
      outline: 0;
      width: 50%;
      max-width: 81.75rem;
      top: 41px;
      display: block;
      .close-button {
        margin: 0;
        overflow: visible;
        text-transform: none;
        padding: 0;
        border: 0;
        background: 0 0;
        appearance: none;
        border-radius: .25rem;
        position: absolute;
        z-index: 10;
        color: #413e37;
        cursor: pointer;
        right: 1rem;
        top: .5rem;
        font-size: 2em;
        line-height: 1;
        outline: 0;
      }
      h4 {
        -webkit-font-smoothing: antialiased;
        overflow-wrap: break-word;
        margin: 0;
        padding: 0;
        font-style: normal;
        text-rendering: optimizeLegibility;
        margin-top: 0;
        margin-bottom: .875rem;
        font-size: 1.5rem;
        line-height: 1.33333;
        font-family: Montserrat,sans-serif;
        font-weight: 600;
        letter-spacing: -.0375rem;
      }
      .intro {
        line-height: 1.5;
        margin: 0;
        padding: 0;
        font-family: Montserrat,sans-serif;
        color: #888;
        font-weight: 400;
        letter-spacing: -.00625rem;
        font-size: 16px;
        max-width: 100%;
      }
      .text-right {
        font-family: Montserrat,sans-serif,"Helvetica Neue",sans-serif;
        font-weight: 400;
        line-height: 1.5;
        color: #053A7A;
        -webkit-font-smoothing: antialiased;
        margin: 0;
        padding: 0;
        text-align: right;
        margin-bottom: 0;
        button {
          overflow: visible;
          background: 0 0;
          display: inline-block;
          vertical-align: middle;
          margin: 0 0 1rem 0;
          border: 1px solid transparent;
          transition: background-color .25s ease-out,color .25s ease-out;
          -webkit-appearance: none;
          cursor: pointer;
          // background-color: #91c855;
          // color: #053A7A;
          background-color: #5456ff;
          color: #fff;
          font-size: .75rem;
          line-height: 1rem;
          padding: .6875rem 1.5rem;
          border-radius: 1.25rem;
          letter-spacing: 1px;
          text-align: center;
          font-weight: 600;
          text-transform: uppercase;
          min-width: 9.75rem;
          outline: 0;
          height: auto;
        }
      }
    }
  }
  .important-notice {
    font-family: Montserrat,sans-serif,"Helvetica Neue",sans-serif;
    font-weight: 400;
    -webkit-font-smoothing: antialiased;
    margin: 0;
    padding: 0;
    color: #787d78;
    margin-bottom: 2.5rem;
    font-size: .75rem;
    line-height: 1rem;
    p {
      font-family: Montserrat,sans-serif,"Helvetica Neue",sans-serif;
    }
  }
  .agree-box {
    font-size: 100%;
    font-family: Montserrat,sans-serif,"Helvetica Neue",sans-serif;
    font-weight: 400;
    line-height: 1.5;
    color: #053A7A;
    -webkit-font-smoothing: antialiased;
    margin: 0;
    border-radius: .5rem;
    background-color: #f0f4f0;
    padding: 2.5rem;
    margin-bottom: 2.5rem;
    .consent-check-box {
      font-size: .75rem;
      line-height: 1rem;
      appearance: none;
    }

    .consent-check-label {
      font-family: Montserrat,sans-serif,"Helvetica Neue",sans-serif;
      -webkit-font-smoothing: antialiased;
      margin: 0;
      font-size: 1rem;
      line-height: 1.5rem;
      color: #053A7A;
      word-break: break-word;
      display: inline-block;
      vertical-align: baseline;
      margin-right: 1rem;
      margin-bottom: 1rem;
      position: relative;
      padding-left: 1.75rem;
      font-weight: 600!important;
      margin-left: .875rem;
      cursor: pointer;
    }

    .consent-check-label:before {
      background-image: url(../assets/imgs/checkbox.svg);
      width: 1.5rem;
      height: 1.5rem;
      position: absolute;
      top: 0.75rem;
      left: -0.75rem;
      content: '\A';
      background-repeat: no-repeat;
      background-size: contain;
      display: inline-block;
    }

    .checked:before {
      background-image: url(../assets/imgs/checkbox-checked.svg) !important;
    }
    .consent-sign {
      font-family: Montserrat,sans-serif,"Helvetica Neue",sans-serif !important;
      font-weight: 400;
      line-height: 1.5;
      color: #053A7A;
      -webkit-font-smoothing: antialiased;
      margin: 0;
      padding: 0;
      min-width: 0;
      padding-right: .75rem;
      padding-left: .75rem;
      flex: 0 0 33.33333%;
      max-width: 33.33333%;
      text-align: right;
      .text {
        font-family: Montserrat,sans-serif,"Helvetica Neue",sans-serif !important;
        font-weight: 400;
        line-height: 1.5;
        color: #053A7A;
        -webkit-font-smoothing: antialiased;
        text-align: right;
        margin: 0;
        padding: 0;
      }
    }
  }
  .consent-item-wrapper {
    margin-bottom: 2.5rem;
    .consent-item {
      padding: 2.5rem;
      border: 1px solid #c1c4c2;
      cursor: pointer;
      border-radius: 0.5rem;
      margin-bottom: 0.5rem;
      box-shadow: none;
      transition: box-shadow .1s ease-in-out;
      .media-wrap {
        margin-right: 1rem;
      }
      a {
        font-weight: 600;
        text-decoration: underline;
        color: #3282a0;
        cursor: pointer;
        font-family: Montserrat,sans-serif,"Helvetica Neue",sans-serif;
      }
    }
    .consent-item:hover {
        box-shadow: 0 0 16px rgba(0,0,0, 0.1);
    }
  }
  
  .flex-container {
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
  }

  .align-middle {
      -webkit-align-items: center;
      -ms-flex-align: center;
      align-items: center;
  }
  .consent-title {
    margin-bottom: 0.8125rem !important;
  }
  .intro {
    font-size: 100%;
    line-height: 1.5;
    margin: 0;
    padding: 0;
    letter-spacing: -.03125rem;
    font-family: Montserrat,sans-serif;
    color: #787d78;
    font-weight: 400;
    margin-bottom: 2.5rem;
    max-width: 39.375rem;
  }

  #application-notes {
    overflow: auto;
    min-height: 50px;
    display: block;
    box-sizing: border-box;
    margin: 0 0 1rem;
    border-radius: .25rem;
    background-color: #f0f4f0;
    box-shadow: none;
    font-weight: 600;
    transition: box-shadow .5s,border-color .25s ease-in-out,padding-top .25s ease-in-out;
    appearance: none;
    max-width: 100%;
    padding: 1rem;
    font-size: 1rem;
    line-height: 1.5rem;
    color: #053A7A;
    width: 100%;
    margin-bottom: .5rem;
    border: 0;
    resize: vertical;
    height: auto;
    font-family: Montserrat,sans-serif,"Helvetica Neue",sans-serif;
  }

  #application-notes:focus {
    box-shadow: 0 0 0 1px #787d78;
    border: 0;
    outline: 0;
  }

  .remove-padding {
    padding-left: 0 !important;
    padding-right: 0 !important;
  }

  .review-section {
    .m-t-30 {
      margin-top: 1.875rem;
    }
    .amcredit-document-list{
      padding-left: 20px;
      padding-bottom: 20px;
      li {
        font-size: 12px;
        list-style-type: disc;
        color: #696969;
        font-family: Montserrat,sans-serif,"Helvetica Neue",sans-serif;
      }
    }
    .amcredit-text {
      color: #053A7A;
      font-family: Montserrat,sans-serif,"Helvetica Neue",sans-serif;
    }
    .sub-title-margin {
      margin-top: 35px;
    }
    .review-item {
      border-top: 1px solid #e3e6e3;
      border-bottom: 1px solid #e3e6e3;
      padding: 0.25rem 0;
      margin: -1px 0 0 -1px;
      word-break: break-word;
      width: 100%;
      .item-title {
        max-width: 50%;
        -webkit-flex: 0 0 50%;
        -ms-flex: 0 0 50%;
        flex: 0 0 50%;
        font-size: .75rem;
        line-height: 1rem;
        padding: 0.75rem 0;
        color: #787d78;
        margin: 0;
        font-family: Montserrat,sans-serif,"Helvetica Neue",sans-serif;
      }
      .item-value {
        max-width: 50%;
        -webkit-flex: 0 0 50%;
        -ms-flex: 0 0 50%;
        flex: 0 0 50%;
        text-align: right;
        color: #053A7A;
        font-weight: 600;
        font-size: .75rem;
        line-height: 1rem;
        font-family: Montserrat,sans-serif,"Helvetica Neue",sans-serif;
        margin: auto;
      }
    }
    .edit-review {
      height: 1.5rem;
      min-width: 0;
      border: 1px solid #91c855;
      color: #053A7A;
      background-color: transparent;
      outline: 0;
      font-size: .625rem;
      line-height: 1rem;
      padding: 0.25rem 1rem;
      border-radius: 1.25rem;
      letter-spacing: 1px;
      text-align: center;
      font-weight: 600;
      position: absolute;
      right: 0;
      display: inline-block;
      vertical-align: middle;
      margin: 0 0 1rem 0;
    }
    .sub-title {
      color: #538e37;
      font-size: .625rem;
      line-height: 1rem;
      font-weight: 600;
      letter-spacing: .0625rem;
      text-transform: uppercase;
    }
  }
  .delete-add-owner {
    font-size: 20px;
    color: #3282a0;
    text-decoration: none;
    cursor: pointer;
    margin-left: 46%;
  }

  .amcredit-add-owner {
    border: 1px solid #00234D;
    color: #053A7A;
    font-size: .75rem;
    line-height: 1rem;
    padding: 0.6875rem 1.5rem;
    border-radius: 1.25rem;
    letter-spacing: 1px;
    text-align: center;
    font-weight: 600;
    text-transform: uppercase;
    min-width: 9.75rem;
  }
  .amcredit-add-owner:hover {
    border-color: #005fcc;
  }

  .address-check-box {
    font-size: .75rem;
    line-height: 1rem;
    appearance: none;
  }

  .address-check-label {
    cursor: pointer;
    font-weight: 400;
    margin-bottom: 0;
    position: relative;
    padding-left: 1.75rem;
    display: inline-block;
    vertical-align: baseline;
    margin-left: 0.5rem;
    margin-right: 1rem;
    line-height: 1.5rem;
    color: #053A7A;
    font-family: Montserrat,sans-serif,"Helvetica Neue",sans-serif;
  }

  .address-check-label:before {
    background-image: url(../assets/imgs/checkbox.svg);
    width: 1.5rem;
    height: 1.5rem;
    position: absolute;
    top: 0;
    left: -0.5rem;
    content: '\A';
    background-repeat: no-repeat;
    background-size: contain;
    display: inline-block;
  }

  .checked:before {
    background-image: url(../assets/imgs/checkbox-checked.svg) !important;
  }

  hr {
    clear: both;
    height: 0;
    margin: 1.375rem 0;
    border-top: 0;
    border-right: 0;
    border-bottom: 1px solid #c1c4c2;
    border-left: 0;
  }

  label:empty {
      display: none;
  }
  @media print, screen and (min-width: 64em) {
    .minimal-title {
      position: absolute;
      left: 50%;
      -webkit-transform: translateX(-50%);
      -ms-transform: translateX(-50%);
      transform: translateX(-50%);
      padding-bottom: 30px;
    }
  }
  .ls-1 {
    letter-spacing: .0625rem;
  }
  .text-12-16 {
      font-size: .75rem;
      line-height: 1rem;
  }
  .f-w-600 {
      font-weight: 600;
  }
  .uppercase {
      text-transform: uppercase;
  }
  .color-gray-5, .color-grey-5 {
      color: #053A7A;
  }
  .text-center {
      text-align: center;
  }
  .amcredit-font {
      font-family: Montserrat,sans-serif,"Helvetica Neue",sans-serif;
      /* font-weight: 400; */
      line-height: 1.5;
      color: #053A7A;
  }
  h3.title {
    margin-bottom: 2.5rem;
    letter-spacing: -.03125rem;
    max-width: 39.375rem;
    font-family: Montserrat,sans-serif;
    font-weight: 600;
    color: #053A7A;
  }
  h5.color-green {
    margin-top: 0;
    margin-bottom: 0.875rem;
    font-size: 1.25rem;
    line-height: 1.6;
    letter-spacing: -.03125rem;
    font-family: Montserrat,sans-serif;
    font-weight: 600;
    color: #5456ff;
  }
  p.color-red {
    margin-top: 0;
    margin-bottom: 0.875rem;
    font-size: 0.75rem;
    line-height: 1.6;
    letter-spacing: -.03125rem;
    font-family: Montserrat,sans-serif;
    font-weight: 600;
    color: red;
  }
  @media screen and (max-width: 768px) {
    .reveal-overlay {
      #contact-modal {
        width: 90%;
        h4 {
          font-size: 1.5rem !important;
        }
      }
    }
    .agree-box .consent-sign {
      margin-left: 32px;
    }
    .review-section {
      padding-right: 0 !important;
      margin-right: 0 !important;
      margin-left: -7.5px !important;
      .review-item .item-value {
        padding-right: 0 !important;
      }
      .edit-review {
        bottom: 0;
      }
      .sub-title-margin:nth-of-type(2) {
        margin-top: 0;
      }
    }
  }

</style>

<style lang="scss">
  .select-placeholder {
      visibility: hidden;
      opacity: 0;
      position: absolute;
      top: 16px;
      left: 13px;
      font-size: 16px;
      line-height: 24px;
      font-weight: 600;
      color: rgba(30,70,70,.5);
      transition: all .3s;
      pointer-events: none;
    }
    .select-top-placeholder.selected select~span.select-placeholder, .select-top-placeholder select:focus~span.select-placeholder {
      visibility: visible;
      opacity: 1;
      top: 9px;
      font-size: 10px;
      line-height: 12px;
    }

    select:focus ~ .select-placeholder{
      color: #50aad2;
    }

  
  .vue-form-generator .selected.select-top-placeholder .form-control {
    padding: 21px 16px 10px 12px;
    color: #053A7A;
  }

  .vue-form-generator .select-top-placeholder .form-control {
    color: rgba(30,70,70,.5);
  }

  .input-label-placeholder {
    input:not(:placeholder-shown)~span.placeholder {
      top: 55px;
      font-size: 10px;
      line-height: 12px;
    }
    .placeholder {
      position: absolute;
      top: 62px;
      left: 13px;
      font-size: 16px;
      line-height: 24px;
      font-weight: 600;
      color: rgba(30,70,70,.5);
      transition: all .3s;
      pointer-events: none;
    }

    input:focus ~ .placeholder{
      left: 13px;
      color: #50aad2;
      top: 55px;
      font-size: 10px;
      line-height: 12px;
      font-weight: 600;
    }
  }
  .has-error .errors{
    color: red;
    span {
      font-family: Montserrat,sans-serif,"Helvetica Neue",sans-serif;
      font-size: 12px;
    }
  }
  .vue-form-wizard .wizard-header {
    padding-bottom: 40px !important;
  }
  .fa-estate:before {
    content: "1 Property & Loan Information" !important;
    height: 16px;
    font-family: Montserrat,sans-serif,"Helvetica Neue",sans-serif;
    font-size: 12px;
    font-weight: 600;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    text-align: center;
  }
  .fa-sun:before {
    content: "2 Owner Information" !important;
    height: 16px;
    font-family: Montserrat,sans-serif,"Helvetica Neue",sans-serif;
    font-size: 12px;
    font-weight: 600;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    text-align: center;
  }
  .fa-consent:before {
    content: "3 Consent" !important;
    height: 16px;
    font-family: Montserrat,sans-serif,"Helvetica Neue",sans-serif;
    font-size: 12px;
    font-weight: 600;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    text-align: center;
  }
  .fa-rev:before {
    content: "4 Review" !important;
    height: 16px;
    font-family: Montserrat,sans-serif,"Helvetica Neue",sans-serif;
    font-size: 12px;
    font-weight: 600;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    text-align: center;
  }
  .wizard-nav.wizard-nav-pills > li a .wizard-icon{
    color: #787d78;
  }
  .wizard-nav.wizard-nav-pills > li.active a .wizard-icon{
    color: #053A7A !important;
  }
  .wizard-nav.wizard-nav-pills > li:first-child a {
      border-left: 0;
  }
  .wizard-nav.wizard-nav-pills > li:last-child a {
      border-right: 0;
  }
  .wizard-nav.wizard-nav-pills > li a {
    border-left: 1px solid rgba(0,0,0,.1);
    border-right: 1px solid rgba(0,0,0,.1);
  }
  .vue-form-wizard .wizard-tab-content {
    padding-top: 60px !important;
    padding-left: 0 !important;
    padding-right: 0 !important;
  }

  .vue-form-generator .form-group {
    padding-left: 0;
    padding-right: 0;
  }
  .vue-form-generator .form-group label{
    font-weight: 400;
    margin-bottom: 0.625rem;
    word-break: break-word;
    display: block;
    margin: 0;
    font-size: 1rem;
    line-height: 1.5rem;
    color: #053A7A;
    margin-bottom: 0.625rem;
  }
  .vue-form-generator .form-group label span {
    font-family: Montserrat,sans-serif,"Helvetica Neue",sans-serif;
  }

  .radio-list label {
      position: relative;
      padding: 1rem 1.5rem;
      /* width: 12.8125rem; */
      display: inline-block !important;
      margin: 0 0 1rem 0;
      font-size: .75rem;
      line-height: 1rem;
      font-weight: 600!important;
      display: inline-block;
      background: #f0f4f0;
      border-radius: 0.25rem;
      border: 1px solid transparent;
      width: 49.5%;
      color: #053A7A;
      height: 3.4375rem;
  }

  .radio-list label:first-child {
    margin-right: 0.5%;
  }
  .radio-list label:last-child {
    margin-left: 0.5%;
  }
  .financing-type-radio {
    .radio-list label:nth-child(3) {
      margin-left: 0 !important;
    }
  }

  .input-type-radio {
    display: block !important;
    input {
      margin-right: 10px;
    }
  }
  
  .input-type-number{
    input {
      height: 3.4375rem;
      margin: 0 0 0.625rem;
      padding: 1rem;
      -webkit-appearance: none;
      -moz-appearance: none;
      appearance: none;
      border: 0;
      border-radius: 0.25rem;
      background-color: #f0f4f0;
      font-size: 1rem !important;
      font-weight: 600;
      line-height: 1.5;
      color: #053A7A !important;
      background-origin: content-box;
      background-position: right -1rem center;
      background-repeat: no-repeat;
      background-size: 9px 6px;
      padding-right: 1.5rem;
      transition: box-shadow .5s,border-color .25s ease-in-out,padding-top .25s ease-in-out;
    }
  }

  .custom-input label[for="business-information"] {
    margin-top: 0;
    margin-bottom: 0.875rem;
    font-size: 1.25rem;
    line-height: 1.6;
    letter-spacing: -.03125rem;
    font-family: Montserrat,sans-serif;
    font-weight: 600;
    color: #5456ff;
  }

  .custom-input-padding {
    padding-top: 46px;
  }

  .custom-input {
    display: inline-block;
    margin-right: 0.25%;
    margin-bottom: 0 !important;
  }

  .custom-lg-8 {
    max-width: 66.916667% !important;
  }

  .custom-input select{
    margin-bottom: 0.625rem !important;
  }

  .custom-input input{
    height: 3.4375rem;
    margin: 0 0 0.625rem;
    padding: 1rem;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    border: 0;
    border-radius: 0.25rem;
    background-color: #f0f4f0;
    font-size: 1rem;
    font-weight: 600;
    line-height: 1.5;
    color: #053A7A;
    background-origin: content-box;
    background-position: right -1rem center;
    background-repeat: no-repeat;
    background-size: 9px 6px;
    padding-right: 1.5rem;
    transition: box-shadow .5s,border-color .25s ease-in-out,padding-top .25s ease-in-out;
  }

  .field-wrap select {
    height: 3.4375rem;
    margin: 0 0 1.75rem;
    padding: 1rem;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    border: 0;
    border-radius: 0.25rem;
    background-color: #f0f4f0;
    font-size: 1rem;
    font-weight: 600;
    line-height: 1.5;
    color: #6c757d;
    background-origin: content-box;
    background-position: right -1rem center;
    background-repeat: no-repeat;
    background-size: 9px 6px;
    padding-right: 1.5rem;
    transition: box-shadow .5s,border-color .25s ease-in-out,padding-top .25s ease-in-out;
  }

  .field-select.selected select  {
    color: #053A7A;
  }
  .wizard-card-footer {
    padding: 0 !important;
  }
  .vue-form-wizard .wizard-card-footer .wizard-footer-left {
    display: none;
  }

  .vue-form-wizard .wizard-card-footer .wizard-footer-right {
    float: left !important;
  }
  .wizard-footer-right .wizard-btn{
    font-size: .75rem !important;
    line-height: 1rem !important;
    padding: 0.6875rem 1.5rem !important;
    border-radius: 1.25rem !important;
    letter-spacing: 1px !important;
    text-align: center !important;
    font-weight: 600 !important;
    text-transform: uppercase !important;
    min-width: 9.75rem !important;
    background-color: #5456ff !important;
    color: #fff !important;
    border: 0 !important;
    max-width: 26.25rem !important;
    width: 420px !important;
    margin-top: 10px !important;
    margin-bottom: 40px !important;
    font-family: Montserrat,sans-serif,"Helvetica Neue",sans-serif;
  }
  @media screen and (max-width: 768px) {
    .custom-lg-8 {
      max-width: 100% !important;
    }
    .wizard-footer-right .wizard-btn {
      width: 100% !important;
    }

    .custom-input-padding {
      padding-top: 0;

      input:not(:placeholder-shown)~span.placeholder {
        top: 9px;
      }
      .placeholder {
        top: 16px;
      }

      input:focus ~ .placeholder{
        top: 9px;
      }
    }
  }
  
</style>


// WEBPACK FOOTER //
// ApplyRealEstateForm.vue?11d1f9b9